var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// ../../node_modules/@theailab-dev/parchment/dist/account/constants.js
var require_constants = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/account/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.INSTRUCTOR_STATE = exports.INSTITUTION_STATE = exports.SOCIAL_LOGIN_PROVIDER = exports.SOCIAL_ACCOUNT_STATE = exports.ACCOUNT_LIKE_TARGET = exports.ACCOUNT_LIKE_STATE = exports.WITHDRAWAL_CODE = exports.GENDER = exports.STAFF_KINDS = exports.ACCOUNT_KIND = exports.ACCOUNT_STATE = void 0;
    exports.ACCOUNT_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.ACCOUNT_KIND = {
      USER: "USER",
      PARTNER: "PARTNER",
      INSTRUCTOR: "INSTRUCTOR",
      OFFICER: "OFFICER",
      OPERATOR: "OPERATOR",
      ADMIN: "ADMIN",
      SYSTEM: "SYSTEM"
    };
    exports.STAFF_KINDS = [exports.ACCOUNT_KIND.ADMIN, exports.ACCOUNT_KIND.OPERATOR, exports.ACCOUNT_KIND.OFFICER];
    exports.GENDER = {
      FEMALE: "FEMALE",
      MALE: "MALE"
    };
    exports.WITHDRAWAL_CODE = {
      LOW_USAGE: "LOW_USAGE",
      PRIVACY_CONCERNS: "PRIVACY_CONCERNS",
      POOR_SERVICE_QUALITY: "POOR_SERVICE_QUALITY",
      OTHER: "OTHER"
    };
    exports.ACCOUNT_LIKE_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.ACCOUNT_LIKE_TARGET = {
      COURSE: "COURSE"
    };
    exports.SOCIAL_ACCOUNT_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.SOCIAL_LOGIN_PROVIDER = {
      GOOGLE: "GOOGLE",
      KAKAO: "KAKAO"
    };
    exports.INSTITUTION_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.INSTRUCTOR_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/account/index.js
var require_account = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/account/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/auth/constants.js
var require_constants2 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/auth/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMAIL_CERTIFICATION_EXPIRY = exports.EMAIL_VERIFICATION_EXPIRY = exports.PHONE_VERIFICATION_EXPIRY = void 0;
    exports.PHONE_VERIFICATION_EXPIRY = 3 * 60;
    exports.EMAIL_VERIFICATION_EXPIRY = 10 * 60;
    exports.EMAIL_CERTIFICATION_EXPIRY = 7 * 24 * 60 * 60;
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/auth/index.js
var require_auth = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/auth/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants2(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/common/constants.js
var require_constants3 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/common/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SERVICE_NAME = void 0;
    exports.SERVICE_NAME = {
      DUMBLEDORE: "dumbledore",
      FAWKES: "fawkes",
      GRYFFINDOR: "gryffindor",
      HUFFLEPUFF: "hufflepuff",
      LUMOS: "lumos",
      MCGONAGALL: "mcgonagall",
      RAVENCLAW: "ravenclaw"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/common/utils.js
var require_utils = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/common/utils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isNullish = void 0;
    var isNullish = (value) => value === null || value === void 0;
    exports.isNullish = isNullish;
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/common/index.js
var require_common = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/common/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants3(), exports);
    __exportStar(require_utils(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/course/constants.js
var require_constants4 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/course/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LESSON_KIND = exports.LESSON_STATE = exports.CHAPTER_STATE = exports.COURSE_KIND = exports.COURSE_STATE = exports.CATEGORY_STATE = void 0;
    exports.CATEGORY_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.COURSE_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.COURSE_KIND = {
      CAMP: "CAMP",
      CLASS: "CLASS",
      WEBINAR: "WEBINAR"
    };
    exports.CHAPTER_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.LESSON_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.LESSON_KIND = {
      VIDEO: "VIDEO",
      PDF: "PDF",
      TEXT: "TEXT",
      TEMP: "TEMP",
      ZOOM: "ZOOM",
      EXAM: "EXAM",
      CODING: "CODING",
      RETAKE: "RETAKE"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/course/index.js
var require_course = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/course/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants4(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/enrollment/constants.js
var require_constants5 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/enrollment/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CREDITED_LESSON_PROGRESS_STATES = exports.LESSON_PROGRESS_STATE = exports.CERTIFICATE_STATE = exports.ENROLLMENT_KIND = exports.VALID_ENROLLMENT_STATES = exports.CREDITED_ENROLLMENT_STATES = exports.ENROLLMENT_STATE = void 0;
    exports.ENROLLMENT_STATE = {
      IN_PROGRESS: "IN_PROGRESS",
      CREDITED: "CREDITED",
      SUSPENDED: "SUSPENDED",
      COMPLETED: "COMPLETED",
      CANCELED: "CANCELED",
      EXPIRED: "EXPIRED",
      DELETED: "DELETED"
    };
    exports.CREDITED_ENROLLMENT_STATES = [
      exports.ENROLLMENT_STATE.COMPLETED,
      exports.ENROLLMENT_STATE.CREDITED
    ];
    exports.VALID_ENROLLMENT_STATES = [
      exports.ENROLLMENT_STATE.IN_PROGRESS,
      ...exports.CREDITED_ENROLLMENT_STATES
    ];
    exports.ENROLLMENT_KIND = {
      PURCHASE: "PURCHASE",
      GRANT: "GRANT"
    };
    exports.CERTIFICATE_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.LESSON_PROGRESS_STATE = {
      IN_PROGRESS: "IN_PROGRESS",
      CREDITED: "CREDITED",
      COMPLETED: "COMPLETED",
      DELETED: "DELETED"
    };
    exports.CREDITED_LESSON_PROGRESS_STATES = [
      exports.LESSON_PROGRESS_STATE.COMPLETED,
      exports.LESSON_PROGRESS_STATE.CREDITED
    ];
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/enrollment/index.js
var require_enrollment = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/enrollment/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants5(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/notification/constants.js
var require_constants6 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/notification/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMAIL_HISTORY_RESULT = exports.MOBILE_MESSAGE_HISTORY_RESULT = exports.MOBILE_MESSAGE_SERVICE_PROVIDER = exports.MESSENGER_SERVICE_PROVIDER = exports.PUSH_NOTIFICATION_KIND = exports.PUSH_NOTIFICATION_READER_STATE = exports.PUSH_NOTIFICATION_STATE = void 0;
    exports.PUSH_NOTIFICATION_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.PUSH_NOTIFICATION_READER_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.PUSH_NOTIFICATION_KIND = {
      EVENT: "EVENT",
      NEWS: "NEWS",
      ANNOUNCEMENT: "ANNOUNCEMENT",
      PERSONAL: "PERSONAL"
    };
    exports.MESSENGER_SERVICE_PROVIDER = {
      SLACK: "SLACK"
    };
    exports.MOBILE_MESSAGE_SERVICE_PROVIDER = {
      NHN: "NHN",
      SOLAPI: "SOLAPI"
    };
    exports.MOBILE_MESSAGE_HISTORY_RESULT = {
      SUCCESS: "SUCCESS",
      FAIL: "FAIL"
    };
    exports.EMAIL_HISTORY_RESULT = {
      SUCCESS: "SUCCESS",
      FAIL: "FAIL"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/notification/index.js
var require_notification = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/notification/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants6(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/operation/constants.js
var require_constants7 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/operation/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AUDIT_LOG_TARGET = exports.AUDIT_LOG_KIND = exports.BANNER_KIND = exports.BANNER_STATE = exports.ARTICLE_KIND = exports.ARTICLE_STATE = void 0;
    exports.ARTICLE_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.ARTICLE_KIND = {
      EVENT: "EVENT",
      NEWS: "NEWS",
      NOTICE: "NOTICE"
    };
    exports.BANNER_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.BANNER_KIND = {
      MAIN: "MAIN",
      AICE: "AICE"
    };
    exports.AUDIT_LOG_KIND = {
      CREATE: "CREATE",
      UPDATE: "UPDATE",
      DELETE: "DELETE",
      FLUSH: "FLUSH",
      LOGIN: "LOGIN",
      LOGOUT: "LOGOUT"
    };
    exports.AUDIT_LOG_TARGET = {
      ACCOUNT: "ACCOUNT",
      AUTH: "AUTH",
      INSTRUCTOR: "INSTRUCTOR",
      CHAPTER: "CHAPTER",
      COURSE: "COURSE",
      LESSON: "LESSON",
      ENROLLMENT: "ENROLLMENT",
      PRODUCT: "PRODUCT",
      PRODUCT_ITEM: "PRODUCT_ITEM",
      REDIS: "REDIS"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/operation/index.js
var require_operation = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/operation/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants7(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/order/constants.js
var require_constants8 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/order/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ADDITIONAL_SHIPPING_FEE = exports.BASIC_SHIPPING_FEE = exports.DELIVERY_KIND = exports.DELIVERY_STATE = exports.ORDER_PRODUCT_ITEM_KIND = exports.ORDER_PRODUCT_ITEM_STATE = exports.ORDER_PRODUCT_STATE = exports.ORDER_TRANSACTION_KIND = exports.ORDER_TRANSACTION_STATE = exports.ORDER_SHEET_STATE = void 0;
    exports.ORDER_SHEET_STATE = {
      ORDERED: "ORDERED",
      PROCESSING: "PROCESSING",
      PAID: "PAID",
      PAYMENT_FAILED: "PAYMENT_FAILED",
      PARTIALLY_CANCELED: "PARTIALLY_CANCELED",
      CANCELED: "CANCELED",
      CANCELLATION_FAILED: "CANCELLATION_FAILED",
      PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED",
      REFUNDED: "REFUNDED"
    };
    exports.ORDER_TRANSACTION_STATE = {
      READY: "READY",
      PROCESSING: "PROCESSING",
      SUCCEEDED: "SUCCEEDED",
      FAILED: "FAILED"
    };
    exports.ORDER_TRANSACTION_KIND = {
      PAYMENT: "PAYMENT",
      CANCELLATION: "CANCELLATION",
      REFUND: "REFUND"
    };
    exports.ORDER_PRODUCT_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.ORDER_PRODUCT_ITEM_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.ORDER_PRODUCT_ITEM_KIND = {
      REQUIREMENT: "REQUIREMENT",
      OPTION: "OPTION"
    };
    exports.DELIVERY_STATE = {
      ORDERED: "ORDERED",
      PREPARING: "PREPARING",
      SHIPPED: "SHIPPED",
      IN_TRANSIT: "IN_TRANSIT",
      DELIVERED: "DELIVERED",
      CANCELED: "CANCELED"
    };
    exports.DELIVERY_KIND = {
      DELIVERY: "DELIVERY",
      RETURN: "RETURN"
    };
    exports.BASIC_SHIPPING_FEE = 3500;
    exports.ADDITIONAL_SHIPPING_FEE = 5e3;
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/order/index.js
var require_order = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/order/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants8(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/payment/constants.js
var require_constants9 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/payment/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.COUPON_TEMPLATE_TARGET = exports.COUPON_TEMPLATE_EXPIRATION_KIND = exports.COUPON_TEMPLATE_DISCOUNT_KIND = exports.COUPON_TEMPLATE_STATE = exports.COUPON_STATE = exports.PAYMENT_SERVICE_PROVIDER = exports.PAYMENT_STATE = exports.PAYMENT_METHOD = void 0;
    exports.PAYMENT_METHOD = {
      CARD: "CARD",
      COUPON: "COUPON",
      FREE: "FREE",
      TRANSFER: "TRANSFER",
      VBANK: "VBANK"
    };
    exports.PAYMENT_STATE = {
      READY: "READY",
      PROCESSING: "PROCESSING",
      SUCCEEDED: "SUCCEEDED",
      FAILED: "FAILED"
    };
    exports.PAYMENT_SERVICE_PROVIDER = {
      PORTONE: "PORTONE"
    };
    exports.COUPON_STATE = {
      NORMAL: "NORMAL",
      REDEEMED: "REDEEMED",
      EXPIRED: "EXPIRED",
      DELETED: "DELETED"
    };
    exports.COUPON_TEMPLATE_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.COUPON_TEMPLATE_DISCOUNT_KIND = {
      PERCENTAGE: "PERCENTAGE",
      FIXED_AMOUNT: "FIXED_AMOUNT"
    };
    exports.COUPON_TEMPLATE_EXPIRATION_KIND = {
      PERIOD: "PERIOD",
      FIXED_DATE: "FIXED_DATE",
      NONE: "NONE"
    };
    exports.COUPON_TEMPLATE_TARGET = {
      EVERYTHING: "EVERYTHING",
      PRODUCT: "PRODUCT",
      CATEGORY: "CATEGORY"
    };
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/payment/index.js
var require_payment = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/payment/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants9(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/product/constants.js
var require_constants10 = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/product/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAIN_PRODUCT_IDS = exports.CATEGORY_AICE_ID = exports.GOODS_KIND = exports.GOODS_STATE = exports.PRODUCT_PACKAGE_KIND = exports.PRODUCT_PACKAGE_STATE = exports.PRODUCT_ITEM_KIND = exports.PRODUCT_ITEM_STATE = exports.PRODUCT_KIND = exports.PRODUCT_STATE = void 0;
    exports.PRODUCT_STATE = {
      NORMAL: "NORMAL",
      HIDDEN: "HIDDEN",
      DELETED: "DELETED"
    };
    exports.PRODUCT_KIND = {
      SINGLE: "SINGLE",
      COMPOSITE: "COMPOSITE",
      ROADMAP: "ROADMAP"
    };
    exports.PRODUCT_ITEM_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.PRODUCT_ITEM_KIND = {
      COURSE: "COURSE",
      GOODS: "GOODS"
    };
    exports.PRODUCT_PACKAGE_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.PRODUCT_PACKAGE_KIND = {
      REQUIREMENT: "REQUIREMENT",
      OPTION: "OPTION"
    };
    exports.GOODS_STATE = {
      NORMAL: "NORMAL",
      DELETED: "DELETED"
    };
    exports.GOODS_KIND = {
      BOOK: "BOOK"
    };
    exports.CATEGORY_AICE_ID = 7;
    exports.MAIN_PRODUCT_IDS = [237, 260];
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/product/index.js
var require_product = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/product/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_constants10(), exports);
  }
});

// ../../node_modules/@theailab-dev/parchment/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/@theailab-dev/parchment/dist/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_account(), exports);
    __exportStar(require_auth(), exports);
    __exportStar(require_common(), exports);
    __exportStar(require_course(), exports);
    __exportStar(require_enrollment(), exports);
    __exportStar(require_notification(), exports);
    __exportStar(require_operation(), exports);
    __exportStar(require_order(), exports);
    __exportStar(require_payment(), exports);
    __exportStar(require_product(), exports);
  }
});

// src/sort-filter-options.ts
import { ApiProperty } from "@nestjs/swagger";
var SortField = class {
  constructor(field, label) {
    this.field = field;
    this.label = label;
  }
};
__decorateClass([
  ApiProperty({ description: "\uC815\uB82C \uD544\uB4DC\uBA85", example: "createdAt", type: String })
], SortField.prototype, "field", 2);
__decorateClass([
  ApiProperty({ description: "\uC815\uB82C \uD544\uB4DC \uB77C\uBCA8", example: "\uC0DD\uC131\uC77C", type: String })
], SortField.prototype, "label", 2);
var FilterValue = class {
  constructor(value, label) {
    this.value = value;
    this.label = label;
  }
};
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uAC12", example: "NORMAL", type: String })
], FilterValue.prototype, "value", 2);
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uAC12 \uB77C\uBCA8", example: "\uC815\uC0C1", type: String })
], FilterValue.prototype, "label", 2);
var FilterField = class {
  constructor(key, label, values) {
    this.key = key;
    this.label = label;
    this.values = values;
  }
};
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uD0A4", example: "state", type: String })
], FilterField.prototype, "key", 2);
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uB77C\uBCA8", example: "\uACC4\uC815 \uC0C1\uD0DC", type: String })
], FilterField.prototype, "label", 2);
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uAC12 \uBAA9\uB85D", type: [FilterValue] })
], FilterField.prototype, "values", 2);
var SortFilterOptions = class {
  constructor(sortFields, sortOrders, filters) {
    this.sortFields = sortFields;
    this.sortOrders = sortOrders;
    this.filters = filters;
  }
};
__decorateClass([
  ApiProperty({ description: "\uC815\uB82C \uAC00\uB2A5\uD55C \uD544\uB4DC \uBAA9\uB85D", type: [SortField] })
], SortFilterOptions.prototype, "sortFields", 2);
__decorateClass([
  ApiProperty({ description: "\uC815\uB82C \uC21C\uC11C \uBAA9\uB85D", example: ["ASC", "DESC"], type: [String] })
], SortFilterOptions.prototype, "sortOrders", 2);
__decorateClass([
  ApiProperty({ description: "\uD544\uD130 \uD544\uB4DC \uBAA9\uB85D", type: [FilterField] })
], SortFilterOptions.prototype, "filters", 2);

// src/paginated-response.dto.ts
import { ApiProperty as ApiProperty2 } from "@nestjs/swagger";
var PaginationMeta = class {
};
__decorateClass([
  ApiProperty2({ description: "\uD604\uC7AC \uD398\uC774\uC9C0 \uBC88\uD638", example: 1, type: Number })
], PaginationMeta.prototype, "page", 2);
__decorateClass([
  ApiProperty2({ description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218", example: 10, type: Number })
], PaginationMeta.prototype, "limit", 2);
__decorateClass([
  ApiProperty2({ description: "\uC804\uCCB4 \uD56D\uBAA9 \uC218", example: 100, type: Number })
], PaginationMeta.prototype, "total", 2);
__decorateClass([
  ApiProperty2({ description: "\uC804\uCCB4 \uD398\uC774\uC9C0 \uC218", example: 10, type: Number })
], PaginationMeta.prototype, "totalPages", 2);
__decorateClass([
  ApiProperty2({
    description: "\uD604\uC7AC \uD398\uC774\uC9C0\uC758 \uD56D\uBAA9 \uC218",
    example: 10,
    type: Number
  })
], PaginationMeta.prototype, "itemCount", 2);
var PaginatedResponseDto = class {
};
__decorateClass([
  ApiProperty2({
    description: "\uC870\uD68C\uB41C \uB370\uC774\uD130 \uBAA9\uB85D",
    isArray: true,
    type: () => Object
  })
], PaginatedResponseDto.prototype, "data", 2);
__decorateClass([
  ApiProperty2({
    description: "\uD398\uC774\uC9C0\uB124\uC774\uC158 \uBA54\uD0C0\uB370\uC774\uD130",
    type: PaginationMeta
  })
], PaginatedResponseDto.prototype, "meta", 2);

// src/account.dto.ts
var import_parchment2 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty4, ApiPropertyOptional as ApiPropertyOptional2 } from "@nestjs/swagger";
import { Type as Type2 } from "class-transformer";
import { IsOptional as IsOptional2, IsInt as IsInt2, Min as Min2, IsString, IsEnum as IsEnum2, IsNotEmpty as IsNotEmpty2, MinLength } from "class-validator";

// src/enrollment.dto.ts
var import_parchment = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty3, ApiPropertyOptional } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsEnum, IsNotEmpty, IsOptional, IsInt, Min, IsDateString, IsArray, ValidateNested } from "class-validator";
var ENROLLMENT_STATE_LABELS = {
  IN_PROGRESS: "\uC218\uAC15\uC911",
  COMPLETED: "\uC644\uB8CC",
  CREDITED: "\uC218\uB8CC",
  SUSPENDED: "\uC911\uB2E8",
  CANCELED: "\uCDE8\uC18C",
  EXPIRED: "\uB9CC\uB8CC",
  DELETED: "\uC0AD\uC81C"
};
var canChangeEnrollmentState = (currentState) => {
  return currentState !== import_parchment.ENROLLMENT_STATE.COMPLETED;
};
var AccountEnrollmentListItemDto = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 ID", example: 1, type: Number })
], AccountEnrollmentListItemDto.prototype, "id", 2);
__decorateClass([
  ApiProperty3({ description: "\uAC15\uC758 ID", example: 1, type: Number })
], AccountEnrollmentListItemDto.prototype, "courseId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 \uC0C1\uD0DC", example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS, enum: import_parchment.ENROLLMENT_STATE })
], AccountEnrollmentListItemDto.prototype, "state", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC2DC\uC791\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountEnrollmentListItemDto.prototype, "enrolledAt", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uAC15\uC758 \uC815\uBCF4",
    example: {
      id: 1,
      title: "React \uAE30\uCD08 \uAC15\uC758"
    },
    type: Object
  })
], AccountEnrollmentListItemDto.prototype, "course", 2);
var EnrollmentDetailDto = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 ID", example: 1, type: Number })
], EnrollmentDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC0C1\uD0DC",
    enum: import_parchment.ENROLLMENT_STATE,
    example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS
  }),
  IsEnum(import_parchment.ENROLLMENT_STATE),
  IsNotEmpty()
], EnrollmentDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC885\uB958",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  }),
  IsEnum(import_parchment.ENROLLMENT_KIND),
  IsNotEmpty()
], EnrollmentDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty3({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], EnrollmentDetailDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty3({ description: "\uAC15\uC758 ID", example: 1, type: Number })
], EnrollmentDetailDto.prototype, "courseId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC8FC\uBB38\uC11C ID", example: 1, type: Number })
], EnrollmentDetailDto.prototype, "orderSheetId", 2);
__decorateClass([
  ApiProperty3({
    description: "\uB9CC\uB8CC\uC77C",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "expireAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC2DC\uC791\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "enrolledAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC644\uB8CC\uC77C",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "completedAt", 2);
__decorateClass([
  ApiProperty3({ description: "\uC804\uCCB4 \uB808\uC2A8 \uC218", example: 10, type: Number })
], EnrollmentDetailDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiProperty3({ description: "\uC644\uB8CC\uD55C \uB808\uC2A8 \uC218", example: 5, type: Number })
], EnrollmentDetailDto.prototype, "completedLessonCount", 2);
__decorateClass([
  ApiProperty3({
    description: "\uB9C8\uC9C0\uB9C9 \uC218\uAC15\uC77C",
    example: "2024-01-15T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentDetailDto.prototype, "lastAttendedAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uB9C8\uC9C0\uB9C9 \uC218\uAC15 \uB808\uC2A8 ID",
    example: 5,
    nullable: true,
    type: Number
  })
], EnrollmentDetailDto.prototype, "lastLessonId", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uB8CC\uC99D \uBC1C\uAE09 \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], EnrollmentDetailDto.prototype, "isCertificateIssued", 2);
__decorateClass([
  ApiProperty3({
    description: "\uD559\uC2B5 \uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], EnrollmentDetailDto.prototype, "isMaterialsDownloaded", 2);
__decorateClass([
  ApiProperty3({
    description: "\uAC15\uC758 \uC815\uBCF4",
    example: {
      id: 1,
      title: "React \uAE30\uCD08 \uAC15\uC758",
      state: import_parchment.COURSE_STATE.NORMAL,
      kind: import_parchment.COURSE_KIND.WEBINAR,
      level: "\uCD08\uAE09",
      totalLessonCount: 10,
      totalDuration: "10\uC2DC\uAC04 30\uBD84"
    },
    type: Object
  })
], EnrollmentDetailDto.prototype, "course", 2);
__decorateClass([
  ApiProperty3({
    description: "\uACC4\uC815 \uC815\uBCF4",
    example: {
      id: 1,
      name: "\uD64D\uAE38\uB3D9",
      email: "user@example.com",
      phone: "010-1234-5678"
    },
    type: Object
  })
], EnrollmentDetailDto.prototype, "account", 2);
var EnrollmentListItemDto = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 ID", example: 1, type: Number })
], EnrollmentListItemDto.prototype, "id", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC0DD\uC131\uC77C (\uAD6C\uB9E4\uB0A0\uC9DC)",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentListItemDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentListItemDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC720\uD615",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  }),
  IsEnum(import_parchment.ENROLLMENT_KIND),
  IsNotEmpty()
], EnrollmentListItemDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC0C1\uD0DC",
    enum: import_parchment.ENROLLMENT_STATE,
    example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS
  }),
  IsEnum(import_parchment.ENROLLMENT_STATE),
  IsNotEmpty()
], EnrollmentListItemDto.prototype, "state", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC2DC\uC791\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentListItemDto.prototype, "enrolledAt", 2);
__decorateClass([
  ApiProperty3({ description: "\uC644\uB8CC\uD55C \uB808\uC2A8 \uC218", example: 3, type: Number })
], EnrollmentListItemDto.prototype, "completedLessonCount", 2);
__decorateClass([
  ApiProperty3({ description: "\uC804\uCCB4 \uB808\uC2A8 \uC218", example: 10, type: Number })
], EnrollmentListItemDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiProperty3({
    description: "\uCF54\uC2A4 \uC815\uBCF4",
    example: { id: 1, title: "React \uAE30\uCD08 \uAC15\uC758" },
    type: Object
  })
], EnrollmentListItemDto.prototype, "course", 2);
__decorateClass([
  ApiProperty3({
    description: "\uACC4\uC815 \uC815\uBCF4",
    example: { id: 1, name: "\uD64D\uAE38\uB3D9", email: "user@example.com", phone: "010-1234-5678" },
    type: Object
  })
], EnrollmentListItemDto.prototype, "account", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC0C1\uD488 \uC815\uBCF4 (\uAD6C\uB9E4\uD55C \uACBD\uC6B0)",
    example: { id: 1, title: "React \uC644\uBCBD \uB9C8\uC2A4\uD130 \uD328\uD0A4\uC9C0" },
    type: Object,
    nullable: true
  })
], EnrollmentListItemDto.prototype, "product", 2);
var GetAccountEnrollmentsResponse = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 \uBAA9\uB85D", type: [AccountEnrollmentListItemDto] })
], GetAccountEnrollmentsResponse.prototype, "data", 2);
__decorateClass([
  ApiProperty3({ description: "\uC804\uCCB4 \uC218\uAC15 \uC218", example: 100, type: Number })
], GetAccountEnrollmentsResponse.prototype, "total", 2);
__decorateClass([
  ApiProperty3({ description: "\uD604\uC7AC \uD398\uC774\uC9C0", example: 1, type: Number })
], GetAccountEnrollmentsResponse.prototype, "page", 2);
__decorateClass([
  ApiProperty3({ description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218", example: 20, type: Number })
], GetAccountEnrollmentsResponse.prototype, "limit", 2);
__decorateClass([
  ApiProperty3({ description: "\uC804\uCCB4 \uD398\uC774\uC9C0 \uC218", example: 5, type: Number })
], GetAccountEnrollmentsResponse.prototype, "totalPages", 2);
var GetEnrollmentsResponse = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 \uBAA9\uB85D", type: [EnrollmentListItemDto] })
], GetEnrollmentsResponse.prototype, "data", 2);
__decorateClass([
  ApiProperty3({
    description: "\uD398\uC774\uC9C0\uB124\uC774\uC158 \uBA54\uD0C0 \uC815\uBCF4",
    example: {
      page: 1,
      limit: 20,
      total: 100,
      totalPages: 5,
      itemCount: 20
    },
    type: Object
  })
], GetEnrollmentsResponse.prototype, "meta", 2);
var UpdateEnrollmentStateDto = class {
};
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC0C1\uD0DC (COMPLETED\uAC00 \uC544\uB2CC \uC0C1\uD0DC\uC5D0\uC11C \uB2E4\uB978 \uC0C1\uD0DC\uB85C \uBCC0\uACBD \uAC00\uB2A5)",
    enum: import_parchment.ENROLLMENT_STATE,
    example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS
  }),
  IsEnum(import_parchment.ENROLLMENT_STATE),
  IsNotEmpty()
], UpdateEnrollmentStateDto.prototype, "state", 2);
var GetEnrollmentsParams = class {
  constructor() {
    this.page = 1;
    this.limit = 5;
  }
};
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 5,
    minimum: 1,
    default: 5,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uD544\uD130 \uD0C0\uC785 (product \uB610\uB294 course)",
    example: "course",
    enum: ["course", "product"]
  }),
  IsOptional()
], GetEnrollmentsParams.prototype, "filterType", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uAC80\uC0C9\uC5B4 (\uC120\uD0DD\uD55C \uD0C0\uC785\uC758 ID \uB610\uB294 Title)",
    example: "React",
    type: String
  }),
  IsOptional()
], GetEnrollmentsParams.prototype, "search", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC2DC\uC791 \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-01-01",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsParams.prototype, "startDate", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC885\uB8CC \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-12-31",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsParams.prototype, "endDate", 2);
var GetEnrollmentsByProductParams = class {
  constructor() {
    this.page = 1;
    this.limit = 5;
  }
};
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsByProductParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 5,
    minimum: 1,
    default: 5,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsByProductParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC218\uAC15 \uC885\uB958 \uD544\uD130 (\uAD6C\uB9E4/\uBD80\uC5EC)",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  }),
  IsOptional(),
  IsEnum(import_parchment.ENROLLMENT_KIND)
], GetEnrollmentsByProductParams.prototype, "filterKind", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC2DC\uC791 \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-01-01",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsByProductParams.prototype, "startDate", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC885\uB8CC \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-12-31",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsByProductParams.prototype, "endDate", 2);
var GetEnrollmentsByCourseParams = class {
  constructor() {
    this.page = 1;
    this.limit = 5;
  }
};
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsByCourseParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 5,
    minimum: 1,
    default: 5,
    type: Number
  }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetEnrollmentsByCourseParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC218\uAC15 \uC885\uB958 \uD544\uD130 (\uAD6C\uB9E4/\uBD80\uC5EC)",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  }),
  IsOptional(),
  IsEnum(import_parchment.ENROLLMENT_KIND)
], GetEnrollmentsByCourseParams.prototype, "filterKind", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC2DC\uC791 \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-01-01",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsByCourseParams.prototype, "startDate", 2);
__decorateClass([
  ApiPropertyOptional({
    description: "\uC885\uB8CC \uB0A0\uC9DC (YYYY-MM-DD)",
    example: "2024-12-31",
    type: String
  }),
  IsOptional(),
  IsDateString()
], GetEnrollmentsByCourseParams.prototype, "endDate", 2);
var EnrollmentByProductDto = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 ID", example: 1, type: Number })
], EnrollmentByProductDto.prototype, "id", 2);
__decorateClass([
  ApiProperty3({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], EnrollmentByProductDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 \uC0C1\uD0DC", enum: import_parchment.ENROLLMENT_STATE, example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS }),
  IsEnum(import_parchment.ENROLLMENT_STATE),
  IsNotEmpty()
], EnrollmentByProductDto.prototype, "state", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC885\uB958 (\uAD6C\uB9E4/\uBD80\uC5EC)",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  })
], EnrollmentByProductDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC2DC\uC791\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentByProductDto.prototype, "enrolledAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC0DD\uC131\uC77C (\uAD6C\uB9E4\uB0A0\uC9DC)",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentByProductDto.prototype, "createdAt", 2);
var EnrollmentByCourseDto = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 ID", example: 1, type: Number })
], EnrollmentByCourseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty3({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], EnrollmentByCourseDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15 \uC0C1\uD0DC", enum: import_parchment.ENROLLMENT_STATE, example: import_parchment.ENROLLMENT_STATE.IN_PROGRESS }),
  IsEnum(import_parchment.ENROLLMENT_STATE),
  IsNotEmpty()
], EnrollmentByCourseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC885\uB958 (\uAD6C\uB9E4/\uBD80\uC5EC)",
    enum: import_parchment.ENROLLMENT_KIND,
    example: import_parchment.ENROLLMENT_KIND.PURCHASE
  })
], EnrollmentByCourseDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC218\uAC15 \uC2DC\uC791\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], EnrollmentByCourseDto.prototype, "enrolledAt", 2);
__decorateClass([
  ApiProperty3({
    description: "\uC0DD\uC131\uC77C (\uAD6C\uB9E4\uB0A0\uC9DC)",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], EnrollmentByCourseDto.prototype, "createdAt", 2);
var GetTargetCourseAndAccountIdsQuery = class {
};
__decorateClass([
  ApiPropertyOptional({
    description: "\uD544\uD130 \uD0C0\uC785 (product \uB610\uB294 course)",
    example: "course",
    enum: ["course", "product"]
  }),
  IsNotEmpty()
], GetTargetCourseAndAccountIdsQuery.prototype, "filterType", 2);
__decorateClass([
  ApiPropertyOptional({ description: "\uAC80\uC0C9\uC5B4 (\uC120\uD0DD\uD55C \uD0C0\uC785\uC758 ID \uB610\uB294 Title)", example: "React", type: String }),
  IsNotEmpty()
], GetTargetCourseAndAccountIdsQuery.prototype, "search", 2);
__decorateClass([
  ApiPropertyOptional({ description: "\uC2DC\uC791 \uB0A0\uC9DC (YYYY-MM-DD)", example: "2024-01-01", type: String }),
  IsNotEmpty(),
  IsDateString()
], GetTargetCourseAndAccountIdsQuery.prototype, "startDate", 2);
__decorateClass([
  ApiPropertyOptional({ description: "\uC885\uB8CC \uB0A0\uC9DC (YYYY-MM-DD)", example: "2024-12-31", type: String }),
  IsOptional(),
  IsDateString()
], GetTargetCourseAndAccountIdsQuery.prototype, "endDate", 2);
__decorateClass([
  ApiPropertyOptional({ description: "\uC0C1\uD488 ID", example: 1, type: Number }),
  IsNotEmpty(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetTargetCourseAndAccountIdsQuery.prototype, "targetProductId", 2);
var GetTargetCourseAndAccountIdsResponse = class {
};
__decorateClass([
  ApiProperty3({ description: "\uCF54\uC2A4 ID", example: 1, type: Number }),
  IsNotEmpty(),
  Type(() => Number),
  IsInt(),
  Min(1)
], GetTargetCourseAndAccountIdsResponse.prototype, "courseId", 2);
__decorateClass([
  ApiProperty3({ description: "\uACC4\uC815 ID \uBAA9\uB85D", example: [1, 2, 3], type: [Number] }),
  IsNotEmpty(),
  IsArray(),
  IsInt({ each: true }),
  Min(1, { each: true })
], GetTargetCourseAndAccountIdsResponse.prototype, "accountIds", 2);
var CreateEnrollmentsByRequest = class {
};
__decorateClass([
  ApiProperty3({ description: "\uACC4\uC815 ID", example: 1, required: false, type: Number }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], CreateEnrollmentsByRequest.prototype, "accountId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC0C1\uD488 ID", example: 1, required: false, type: Number }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], CreateEnrollmentsByRequest.prototype, "productId", 2);
var CreateSpecialProductEnrollmentsRequest = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC0C1\uD488 ID", example: 1, required: false, type: Number }),
  IsOptional(),
  Type(() => Number),
  IsInt(),
  Min(1)
], CreateSpecialProductEnrollmentsRequest.prototype, "productId", 2);
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15\uAD8C \uBD80\uC5EC \uB300\uC0C1", type: [GetTargetCourseAndAccountIdsResponse] }),
  IsNotEmpty(),
  IsArray(),
  ValidateNested({ each: true }),
  Type(() => GetTargetCourseAndAccountIdsResponse)
], CreateSpecialProductEnrollmentsRequest.prototype, "targets", 2);
var CreateEnrollmentsResponse = class {
};
__decorateClass([
  ApiProperty3({ description: "\uC218\uAC15\uAD8C ID \uBAA9\uB85D", example: [1, 2, 3], type: [Number] }),
  IsNotEmpty(),
  IsArray(),
  IsInt({ each: true }),
  Min(1, { each: true })
], CreateEnrollmentsResponse.prototype, "enrollmentIds", 2);

// src/account.dto.ts
var SocialAccountDto = class {
};
__decorateClass([
  ApiProperty4({ description: "\uC18C\uC15C \uACC4\uC815 ID", example: 1, type: Number })
], SocialAccountDto.prototype, "id", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], SocialAccountDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], SocialAccountDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty4({ description: "\uC0C1\uD0DC", example: import_parchment2.SOCIAL_ACCOUNT_STATE.NORMAL, enum: import_parchment2.SOCIAL_ACCOUNT_STATE })
], SocialAccountDto.prototype, "state", 2);
__decorateClass([
  ApiProperty4({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], SocialAccountDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty4({ description: "\uC81C\uACF5\uC790", example: import_parchment2.SOCIAL_LOGIN_PROVIDER.KAKAO, enum: import_parchment2.SOCIAL_LOGIN_PROVIDER })
], SocialAccountDto.prototype, "provider", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC81C\uACF5\uC790 \uACC4\uC815 ID",
    example: "123456789",
    type: String
  })
], SocialAccountDto.prototype, "providerAccountId", 2);
var AccountDetailDto = class {
};
__decorateClass([
  ApiProperty4({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], AccountDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty4({ description: "\uACC4\uC815 \uC0C1\uD0DC", example: import_parchment2.ACCOUNT_STATE.NORMAL, enum: import_parchment2.ACCOUNT_STATE })
], AccountDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty4({ description: "\uACC4\uC815 \uC720\uD615", example: import_parchment2.ACCOUNT_KIND.USER, enum: import_parchment2.ACCOUNT_KIND })
], AccountDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC774\uBA54\uC77C",
    example: "user@example.com",
    type: String
  })
], AccountDetailDto.prototype, "email", 2);
__decorateClass([
  ApiProperty4({ description: "\uC774\uB984", example: "\uD64D\uAE38\uB3D9", type: String })
], AccountDetailDto.prototype, "name", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC804\uD654\uBC88\uD638",
    example: "010-1234-5678",
    type: String
  })
], AccountDetailDto.prototype, "phone", 2);
__decorateClass([
  ApiProperty4({ description: "\uC131\uBCC4", example: import_parchment2.GENDER.MALE, nullable: true, enum: import_parchment2.GENDER })
], AccountDetailDto.prototype, "gender", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC0DD\uB144\uC6D4\uC77C",
    example: "1990-01-01",
    nullable: true,
    type: String
  })
], AccountDetailDto.prototype, "dob", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC18C\uC18D\uAE30\uAD00 ID",
    example: 1,
    nullable: true,
    type: Number
  })
], AccountDetailDto.prototype, "institutionId", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC774\uBA54\uC77C \uC778\uC99D\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "emailCertifiedAt", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC804\uD654\uBC88\uD638 \uC778\uC99D\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "phoneCertifiedAt", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC774\uBA54\uC77C \uB9C8\uCF00\uD305 \uB3D9\uC758\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "emailMarketingAgreedAt", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC804\uD654\uBC88\uD638 \uB9C8\uCF00\uD305 \uB3D9\uC758\uC77C",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountDetailDto.prototype, "phoneMarketingAgreedAt", 2);
__decorateClass([
  ApiProperty4({ description: "\uD0C8\uD1F4 \uCF54\uB4DC", example: import_parchment2.WITHDRAWAL_CODE.LOW_USAGE, nullable: true, enum: import_parchment2.WITHDRAWAL_CODE })
], AccountDetailDto.prototype, "withdrawalCode", 2);
__decorateClass([
  ApiProperty4({
    description: "\uD0C8\uD1F4 \uC0AC\uC720",
    example: "\uC11C\uBE44\uC2A4 \uBD88\uB9CC",
    nullable: true,
    type: String
  })
], AccountDetailDto.prototype, "withdrawalReason", 2);
__decorateClass([
  ApiProperty4({ description: "\uC18C\uC15C \uACC4\uC815 \uBAA9\uB85D", type: [SocialAccountDto] })
], AccountDetailDto.prototype, "socialAccounts", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC218\uAC15 \uBAA9\uB85D (\uCD5C\uB300 5\uAC1C)",
    type: [AccountEnrollmentListItemDto]
  })
], AccountDetailDto.prototype, "enrollments", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uC218\uAC15 \uBAA9\uB85D \uBA54\uD0C0 \uC815\uBCF4",
    example: { total: 10, totalPages: 2 },
    type: Object
  })
], AccountDetailDto.prototype, "enrollmentMeta", 2);
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var FilterKey = /* @__PURE__ */ ((FilterKey2) => {
  FilterKey2["STATE"] = "state";
  FilterKey2["KIND"] = "kind";
  FilterKey2["GENDER"] = "gender";
  FilterKey2["SEARCH"] = "search";
  return FilterKey2;
})(FilterKey || {});
var GetAccountsParams = class {
  constructor() {
    this.page = 1;
    this.limit = 10;
    this.sortOrder = "DESC" /* DESC */;
  }
};
__decorateClass([
  ApiPropertyOptional2({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional2(),
  Type2(() => Number),
  IsInt2(),
  Min2(1)
], GetAccountsParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 10,
    minimum: 1,
    default: 10,
    type: Number
  }),
  IsOptional2(),
  Type2(() => Number),
  IsInt2(),
  Min2(1)
], GetAccountsParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uC815\uB82C \uAE30\uC900 \uD544\uB4DC",
    example: "createdAt",
    type: String
  }),
  IsOptional2(),
  IsString()
], GetAccountsParams.prototype, "sortBy", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uC815\uB82C \uC21C\uC11C",
    enum: SortOrder,
    example: "DESC" /* DESC */,
    default: "DESC" /* DESC */,
    type: String
  }),
  IsOptional2(),
  IsEnum2(SortOrder)
], GetAccountsParams.prototype, "sortOrder", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uD544\uD130 \uD0A4 (state, kind, gender, search \uC911 \uD558\uB098)",
    example: "gender" /* GENDER */,
    enum: FilterKey,
    type: String
  }),
  IsOptional2(),
  IsEnum2(FilterKey)
], GetAccountsParams.prototype, "filterKey", 2);
__decorateClass([
  ApiPropertyOptional2({
    description: "\uD544\uD130 \uAC12 (filterKey\uC5D0 \uD574\uB2F9\uD558\uB294 \uAC12, \uCF64\uB9C8\uB85C \uAD6C\uBD84\uD558\uC5EC \uC5EC\uB7EC \uAC12 \uC9C0\uC815 \uAC00\uB2A5)",
    type: String,
    examples: {
      state: { value: import_parchment2.ACCOUNT_STATE.NORMAL, description: "\uACC4\uC815 \uC0C1\uD0DC \uD544\uD130 (NORMAL, DELETED)" },
      kind: { value: import_parchment2.ACCOUNT_KIND.USER, description: "\uACC4\uC815 \uC720\uD615 \uD544\uD130" },
      gender: { value: import_parchment2.GENDER.MALE, description: "\uC131\uBCC4 \uD544\uD130" },
      search: { value: "\uD64D\uAE38\uB3D9", description: "ID, \uC774\uB984, \uC774\uBA54\uC77C, \uC804\uD654\uBC88\uD638 \uAC80\uC0C9" }
    }
  }),
  IsOptional2(),
  IsString()
], GetAccountsParams.prototype, "filterValue", 2);
var ResetAdminPasswordDto = class {
};
__decorateClass([
  ApiProperty4({
    description: "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638",
    example: "currentPassword123",
    type: String
  }),
  IsString(),
  IsNotEmpty2({ message: "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638\uB294 \uD544\uC218\uC785\uB2C8\uB2E4." })
], ResetAdminPasswordDto.prototype, "currentPassword", 2);
__decorateClass([
  ApiProperty4({
    description: "\uC0C8 \uBE44\uBC00\uBC88\uD638 (\uCD5C\uC18C 8\uC790 \uC774\uC0C1)",
    example: "newPassword123",
    type: String,
    minLength: 8
  }),
  IsString(),
  IsNotEmpty2({ message: "\uC0C8 \uBE44\uBC00\uBC88\uD638\uB294 \uD544\uC218\uC785\uB2C8\uB2E4." }),
  MinLength(8, { message: "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C 8\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." })
], ResetAdminPasswordDto.prototype, "newPassword", 2);
var UpdateAccountDto = class {
  // 나중에 확장 가능하도록 Partial 타입 구조 유지
  // 필요시 아래 필드들을 추가할 수 있음:
  // state?: AccountState;
  // email?: string;
  // name?: string;
  // phone?: string;
  // gender?: Gender | null;
  // dob?: string | null;
  // institutionId?: number | null;
};
__decorateClass([
  ApiPropertyOptional2({
    description: "\uACC4\uC815 \uC720\uD615",
    example: import_parchment2.ACCOUNT_KIND.ADMIN,
    enum: import_parchment2.ACCOUNT_KIND,
    type: String
  }),
  IsOptional2(),
  IsEnum2(import_parchment2.ACCOUNT_KIND)
], UpdateAccountDto.prototype, "kind", 2);

// src/account-options.ts
var import_parchment4 = __toESM(require_dist(), 1);

// src/role.const.ts
var import_parchment3 = __toESM(require_dist(), 1);
var ROLE_PRIORITY = {
  [import_parchment3.ACCOUNT_KIND.SYSTEM]: 7,
  [import_parchment3.ACCOUNT_KIND.ADMIN]: 6,
  [import_parchment3.ACCOUNT_KIND.OPERATOR]: 5,
  [import_parchment3.ACCOUNT_KIND.OFFICER]: 4,
  [import_parchment3.ACCOUNT_KIND.INSTRUCTOR]: 3,
  [import_parchment3.ACCOUNT_KIND.PARTNER]: 2,
  [import_parchment3.ACCOUNT_KIND.USER]: 1
};
var ADMIN_ROLES = [
  import_parchment3.ACCOUNT_KIND.SYSTEM,
  import_parchment3.ACCOUNT_KIND.ADMIN,
  import_parchment3.ACCOUNT_KIND.OPERATOR,
  import_parchment3.ACCOUNT_KIND.OFFICER
];
var ROLE_LABELS = {
  [import_parchment3.ACCOUNT_KIND.USER]: "\uC0AC\uC6A9\uC790",
  [import_parchment3.ACCOUNT_KIND.PARTNER]: "\uD30C\uD2B8\uB108",
  [import_parchment3.ACCOUNT_KIND.INSTRUCTOR]: "\uAC15\uC0AC",
  [import_parchment3.ACCOUNT_KIND.OFFICER]: "\uC9C1\uC6D0",
  [import_parchment3.ACCOUNT_KIND.OPERATOR]: "\uC6B4\uC601\uC790",
  [import_parchment3.ACCOUNT_KIND.ADMIN]: "\uAD00\uB9AC\uC790",
  [import_parchment3.ACCOUNT_KIND.SYSTEM]: "\uC2DC\uC2A4\uD15C"
};
var ACCOUNT_KIND_OPTIONS_ORDER = [
  import_parchment3.ACCOUNT_KIND.USER,
  import_parchment3.ACCOUNT_KIND.PARTNER,
  import_parchment3.ACCOUNT_KIND.INSTRUCTOR,
  import_parchment3.ACCOUNT_KIND.OFFICER,
  import_parchment3.ACCOUNT_KIND.OPERATOR,
  import_parchment3.ACCOUNT_KIND.ADMIN
];
function compareRolePriority(role1, role2) {
  return ROLE_PRIORITY[role1] - ROLE_PRIORITY[role2];
}
function hasRoleOrHigher(userRole, requiredRole) {
  return ROLE_PRIORITY[userRole] >= ROLE_PRIORITY[requiredRole];
}
function getHigherRoles(currentRole) {
  const currentPriority = ROLE_PRIORITY[currentRole];
  return Object.keys(ROLE_PRIORITY).filter((role) => ROLE_PRIORITY[role] > currentPriority);
}

// src/account-options.ts
var ACCOUNT_SORT_FIELDS = [
  new SortField("id", "ID"),
  new SortField("email", "\uC774\uBA54\uC77C"),
  new SortField("name", "\uC774\uB984"),
  new SortField("phone", "\uC804\uD654\uBC88\uD638"),
  new SortField("state", "\uC0C1\uD0DC"),
  new SortField("kind", "\uC720\uD615"),
  new SortField("institutionId", "\uC18C\uC18D\uAE30\uAD00 ID"),
  new SortField("emailCertifiedAt", "\uC774\uBA54\uC77C \uC778\uC99D\uC77C"),
  new SortField("phoneCertifiedAt", "\uC804\uD654\uBC88\uD638 \uC778\uC99D\uC77C"),
  new SortField("createdAt", "\uC0DD\uC131\uC77C"),
  new SortField("updatedAt", "\uC218\uC815\uC77C")
];
var ACCOUNT_FILTER_FIELDS = [
  new FilterField("state", "\uACC4\uC815 \uC0C1\uD0DC", [
    new FilterValue(import_parchment4.ACCOUNT_STATE.NORMAL, "\uC815\uC0C1"),
    new FilterValue(import_parchment4.ACCOUNT_STATE.DELETED, "\uC0AD\uC81C")
  ]),
  new FilterField("kind", "\uACC4\uC815 \uC720\uD615", [
    new FilterValue(import_parchment4.ACCOUNT_KIND.USER, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.USER]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.PARTNER, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.PARTNER]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.INSTRUCTOR, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.INSTRUCTOR]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.OFFICER, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.OFFICER]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.OPERATOR, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.OPERATOR]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.ADMIN, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.ADMIN]),
    new FilterValue(import_parchment4.ACCOUNT_KIND.SYSTEM, ROLE_LABELS[import_parchment4.ACCOUNT_KIND.SYSTEM])
  ]),
  new FilterField("gender", "\uC131\uBCC4", [new FilterValue(import_parchment4.GENDER.MALE, "\uB0A8\uC131"), new FilterValue(import_parchment4.GENDER.FEMALE, "\uC5EC\uC131")])
];
var ACCOUNT_SORT_ORDERS = ["ASC", "DESC"];
var ACCOUNT_SEARCH_FIELDS = ["id", "name", "email", "phone"];
function getAccountOptions() {
  return new SortFilterOptions(ACCOUNT_SORT_FIELDS, [...ACCOUNT_SORT_ORDERS], ACCOUNT_FILTER_FIELDS);
}
function getFilterValues(filterKey) {
  const filterField = ACCOUNT_FILTER_FIELDS.find((f) => f.key === filterKey);
  return filterField ? filterField.values.map((v) => v.value) : [];
}

// src/account-response.dto.ts
var import_parchment5 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty5 } from "@nestjs/swagger";
var AccountResponseDto = class {
};
__decorateClass([
  ApiProperty5({ description: "\uACC4\uC815 ID", example: 1, type: Number })
], AccountResponseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty5({ description: "\uC774\uBA54\uC77C", example: "user@example.com", type: String })
], AccountResponseDto.prototype, "email", 2);
__decorateClass([
  ApiProperty5({ description: "\uC0AC\uC6A9\uC790 \uC774\uB984", example: "\uD64D\uAE38\uB3D9", type: String })
], AccountResponseDto.prototype, "name", 2);
__decorateClass([
  ApiProperty5({ description: "\uC804\uD654\uBC88\uD638", example: "+821000000000", type: String })
], AccountResponseDto.prototype, "phone", 2);
__decorateClass([
  ApiProperty5({ description: "\uACC4\uC815 \uC0C1\uD0DC", example: import_parchment5.ACCOUNT_STATE.NORMAL, enum: import_parchment5.ACCOUNT_STATE })
], AccountResponseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty5({ description: "\uACC4\uC815 \uC720\uD615", example: import_parchment5.ACCOUNT_KIND.USER, enum: import_parchment5.ACCOUNT_KIND })
], AccountResponseDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty5({ description: "\uC131\uBCC4", example: import_parchment5.GENDER.MALE, nullable: true, enum: import_parchment5.GENDER })
], AccountResponseDto.prototype, "gender", 2);
__decorateClass([
  ApiProperty5({
    description: "\uC0DD\uB144\uC6D4\uC77C",
    example: "1990-01-01",
    nullable: true,
    type: String,
    format: "date-time"
  })
], AccountResponseDto.prototype, "dob", 2);

// src/auth.dto.ts
var import_parchment6 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty6, ApiPropertyOptional as ApiPropertyOptional3 } from "@nestjs/swagger";
import { IsEmail, IsNotEmpty as IsNotEmpty3, IsString as IsString2 } from "class-validator";
var LoginRequest = class {
};
__decorateClass([
  ApiProperty6({
    description: "\uC774\uBA54\uC77C \uC8FC\uC18C",
    example: "admin@example.com",
    type: String
  }),
  IsEmail({}, { message: "\uC720\uD6A8\uD55C \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694." }),
  IsNotEmpty3({ message: "\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4." })
], LoginRequest.prototype, "email", 2);
__decorateClass([
  ApiProperty6({
    description: "\uBE44\uBC00\uBC88\uD638",
    example: "password123",
    type: String,
    minLength: 8
  }),
  IsString2(),
  IsNotEmpty3({ message: "\uBE44\uBC00\uBC88\uD638\uB294 \uD544\uC218\uC785\uB2C8\uB2E4." })
], LoginRequest.prototype, "password", 2);
var LoginResponse = class {
};
__decorateClass([
  ApiProperty6({
    description: "\uB85C\uADF8\uC778 \uC131\uACF5 \uC5EC\uBD80",
    example: true,
    type: Boolean
  })
], LoginResponse.prototype, "success", 2);
__decorateClass([
  ApiPropertyOptional3({
    description: "Access Token (\uC751\uB2F5 body\uC5D0 \uD3EC\uD568\uB420 \uC218 \uC788\uC74C)",
    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
    type: String
  })
], LoginResponse.prototype, "accessToken", 2);
__decorateClass([
  ApiPropertyOptional3({
    description: "Refresh Token (\uC751\uB2F5 body\uC5D0 \uD3EC\uD568\uB420 \uC218 \uC788\uC74C)",
    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
    type: String
  })
], LoginResponse.prototype, "refreshToken", 2);
var RefreshTokenResponse = class {
};
__decorateClass([
  ApiProperty6({
    description: "\uC0C8\uB85C\uC6B4 Access Token",
    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
    type: String
  })
], RefreshTokenResponse.prototype, "accessToken", 2);
__decorateClass([
  ApiPropertyOptional3({
    description: "\uC0C8\uB85C\uC6B4 Refresh Token (\uC120\uD0DD\uC801)",
    example: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
    type: String
  })
], RefreshTokenResponse.prototype, "refreshToken", 2);
var User = class {
  // 백엔드 Staff와 호환성을 위한 인덱스 시그니처
};
__decorateClass([
  ApiProperty6({
    description: "\uC0AC\uC6A9\uC790 ID",
    example: "1",
    type: String
  })
], User.prototype, "id", 2);
__decorateClass([
  ApiProperty6({
    description: "\uC774\uBA54\uC77C \uC8FC\uC18C",
    example: "admin@example.com",
    type: String
  })
], User.prototype, "email", 2);
__decorateClass([
  ApiProperty6({
    description: "\uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  })
], User.prototype, "name", 2);
__decorateClass([
  ApiProperty6({
    description: "\uC0AC\uC6A9\uC790 \uC720\uD615",
    example: import_parchment6.ACCOUNT_KIND.ADMIN,
    enum: import_parchment6.ACCOUNT_KIND
  })
], User.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional3({
    description: "\uC0AC\uC6A9\uC790\uBA85 (\uD558\uC704 \uD638\uD658\uC131)",
    example: "admin",
    type: String
  })
], User.prototype, "username", 2);

// src/course.dto.ts
var import_parchment7 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty7, ApiPropertyOptional as ApiPropertyOptional4 } from "@nestjs/swagger";
import { Transform, Type as Type3 } from "class-transformer";
import {
  IsString as IsString3,
  IsNotEmpty as IsNotEmpty4,
  IsOptional as IsOptional3,
  IsInt as IsInt3,
  IsEnum as IsEnum3,
  Min as Min3,
  IsBoolean,
  IsDateString as IsDateString2,
  ValidateIf,
  IsArray as IsArray2,
  ValidateNested as ValidateNested2
} from "class-validator";
var COURSE_LEVEL_VALUES = ["\uCD08\uAE09", "\uC911\uAE09", "\uACE0\uAE09"];
var CourseSortBy = /* @__PURE__ */ ((CourseSortBy2) => {
  CourseSortBy2["CREATED_AT"] = "createdAt";
  CourseSortBy2["UPDATED_AT"] = "updatedAt";
  CourseSortBy2["TITLE"] = "title";
  CourseSortBy2["TOTAL_LESSON_COUNT"] = "totalLessonCount";
  return CourseSortBy2;
})(CourseSortBy || {});
var CourseFilterKey = /* @__PURE__ */ ((CourseFilterKey2) => {
  CourseFilterKey2["SEARCH"] = "search";
  CourseFilterKey2["LEVEL"] = "level";
  CourseFilterKey2["KIND"] = "kind";
  return CourseFilterKey2;
})(CourseFilterKey || {});
var GetCoursesParams = class {
  constructor() {
    this.page = 1;
    this.limit = 20;
    this.sortBy = "createdAt" /* CREATED_AT */;
    this.sortOrder = "DESC";
  }
};
__decorateClass([
  ApiPropertyOptional4({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], GetCoursesParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 20,
    minimum: 1,
    default: 20,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], GetCoursesParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC815\uB82C \uAE30\uC900 \uD544\uB4DC",
    enum: CourseSortBy,
    example: "createdAt" /* CREATED_AT */,
    default: "createdAt" /* CREATED_AT */,
    type: String
  }),
  IsOptional3(),
  IsEnum3(CourseSortBy)
], GetCoursesParams.prototype, "sortBy", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC815\uB82C \uC21C\uC11C (ASC: \uC624\uB984\uCC28\uC21C, DESC: \uB0B4\uB9BC\uCC28\uC21C)",
    enum: ["ASC", "DESC"],
    example: "DESC",
    default: "DESC",
    type: String
  }),
  IsOptional3(),
  IsEnum3(["ASC", "DESC"])
], GetCoursesParams.prototype, "sortOrder", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uD544\uD130 \uD0A4 (search: \uAC80\uC0C9(\uC81C\uBAA9/\uAC15\uC0AC\uC774\uB984), level: \uB09C\uC774\uB3C4, kind: \uC720\uD615)",
    enum: CourseFilterKey,
    example: "search" /* SEARCH */,
    type: String
  }),
  IsOptional3(),
  IsEnum3(CourseFilterKey)
], GetCoursesParams.prototype, "filterKey", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uD544\uD130 \uAC12 (filterKey\uC5D0 \uD574\uB2F9\uD558\uB294 \uAC12, level\uC758 \uACBD\uC6B0 \uCF64\uB9C8\uB85C \uAD6C\uBD84\uD558\uC5EC \uC5EC\uB7EC \uAC12 \uC9C0\uC815 \uAC00\uB2A5)",
    example: "\uCD08\uAE09",
    type: String,
    examples: {
      search: {
        value: "React",
        description: "\uC81C\uBAA9, \uAC15\uC0AC \uC774\uB984 \uAC80\uC0C9"
      },
      level: {
        value: "\uCD08\uAE09,\uC911\uAE09",
        description: "\uB09C\uC774\uB3C4 \uD544\uD130 (\uCF64\uB9C8\uB85C \uAD6C\uBD84\uD558\uC5EC \uC5EC\uB7EC \uAC12 \uC9C0\uC815 \uAC00\uB2A5)"
      },
      kind: {
        value: import_parchment7.COURSE_KIND.WEBINAR,
        description: "\uC720\uD615 \uD544\uD130"
      }
    }
  }),
  IsOptional3(),
  IsString3()
], GetCoursesParams.prototype, "filterValue", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uCE74\uD14C\uACE0\uB9AC ID\uB85C \uD544\uD130\uB9C1",
    example: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3()
], GetCoursesParams.prototype, "categoryId", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC0AC ID\uB85C \uD544\uD130\uB9C1",
    example: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3()
], GetCoursesParams.prototype, "instructorId", 2);
var CourseResponseDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 ID", example: 1, type: Number })
], CourseResponseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758",
    type: String
  })
], CourseResponseDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({
    description: "\uB09C\uC774\uB3C4",
    example: "\uCD08\uAE09",
    nullable: true,
    type: String
  })
], CourseResponseDto.prototype, "level", 2);
__decorateClass([
  ApiProperty7({ description: "\uC0C1\uD0DC", example: import_parchment7.COURSE_STATE.NORMAL, enum: import_parchment7.COURSE_STATE })
], CourseResponseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 \uC885\uB958", example: import_parchment7.COURSE_KIND.WEBINAR, enum: import_parchment7.COURSE_KIND })
], CourseResponseDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty7({ description: "\uC804\uCCB4 \uB808\uC2A8 \uC218", example: 10, type: Number })
], CourseResponseDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10\uC2DC\uAC04 30\uBD84",
    nullable: true,
    type: String
  })
], CourseResponseDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0AC\uC804 \uC9C0\uC2DD",
    example: "JavaScript \uAE30\uCD08",
    nullable: true,
    type: String
  })
], CourseResponseDto.prototype, "preknowledge", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], CourseResponseDto.prototype, "startAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], CourseResponseDto.prototype, "endAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  })
], CourseResponseDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC2A4\uD398\uC15C \uAC15\uC758 \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], CourseResponseDto.prototype, "isSpecial", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], CourseResponseDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], CourseResponseDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC6D0\uAC00 (\uAC15\uC758\uC5D0 \uC5F0\uACB0\uB41C product_item\uC758 originalPrice)",
    example: 1e5,
    nullable: true,
    type: Number
  })
], CourseResponseDto.prototype, "price", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C ID (\uAC15\uC758\uC5D0 \uC5F0\uACB0\uB41C product_item\uC758 id)",
    example: 1,
    nullable: true,
    type: Number
  })
], CourseResponseDto.prototype, "productItemId", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC815\uBCF4",
    example: {
      id: 1,
      title: "\uD504\uB860\uD2B8\uC5D4\uB4DC",
      thumbnailUrl: "https://example.com/image.jpg"
    },
    nullable: true,
    type: Object
  })
], CourseResponseDto.prototype, "category", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC0AC \uC815\uBCF4",
    example: {
      id: 1,
      name: "\uD64D\uAE38\uB3D9",
      occupation: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
      imageUrl: "https://example.com/image.jpg"
    },
    nullable: true,
    type: Object
  })
], CourseResponseDto.prototype, "instructor", 2);
var CourseDetailDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 ID", example: 1, type: Number })
], CourseDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758",
    type: String
  })
], CourseDetailDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({
    description: "\uB09C\uC774\uB3C4",
    example: "\uCD08\uAE09",
    nullable: true,
    type: String
  })
], CourseDetailDto.prototype, "level", 2);
__decorateClass([
  ApiProperty7({ description: "\uC0C1\uD0DC", example: import_parchment7.COURSE_STATE.NORMAL, enum: import_parchment7.COURSE_STATE })
], CourseDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 \uC885\uB958", example: import_parchment7.COURSE_KIND.WEBINAR, enum: import_parchment7.COURSE_KIND })
], CourseDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty7({ description: "\uC804\uCCB4 \uB808\uC2A8 \uC218", example: 10, type: Number })
], CourseDetailDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10\uC2DC\uAC04 30\uBD84",
    nullable: true,
    type: String
  })
], CourseDetailDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0AC\uC804 \uC9C0\uC2DD",
    example: "JavaScript \uAE30\uCD08",
    nullable: true,
    type: String
  })
], CourseDetailDto.prototype, "preknowledge", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], CourseDetailDto.prototype, "startAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], CourseDetailDto.prototype, "endAt", 2);
__decorateClass([
  ApiProperty7({ description: "\uC218\uAC15\uAD8C \uC720\uD6A8 \uAE30\uAC04 (\uC77C)", example: 30, nullable: true, type: Number })
], CourseDetailDto.prototype, "periodDays", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  })
], CourseDetailDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC2A4\uD398\uC15C \uAC15\uC758 \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], CourseDetailDto.prototype, "isSpecial", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: Date
  })
], CourseDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: Date
  })
], CourseDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty7({ description: "\uAC00\uACA9", example: 1e5, type: Number })
], CourseDetailDto.prototype, "price", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC124\uBA85",
    example: "\uAC15\uC758 \uC124\uBA85\uC785\uB2C8\uB2E4.",
    type: String
  })
], CourseDetailDto.prototype, "description", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC815\uBCF4",
    example: {
      id: 1,
      title: "\uD504\uB860\uD2B8\uC5D4\uB4DC",
      thumbnailUrl: "https://example.com/image.jpg"
    },
    nullable: true,
    type: Object
  })
], CourseDetailDto.prototype, "category", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC0AC \uC815\uBCF4",
    example: {
      id: 1,
      name: "\uD64D\uAE38\uB3D9",
      occupation: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
      imageUrl: "https://example.com/image.jpg",
      email: "instructor@example.com"
    },
    nullable: true,
    type: Object
  })
], CourseDetailDto.prototype, "instructor", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCC55\uD130 \uBAA9\uB85D",
    type: [Object]
  })
], CourseDetailDto.prototype, "chapters", 2);
var LessonDetailDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uB808\uC2A8 ID", example: 1, type: Number })
], LessonDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty7({
    description: "\uB808\uC2A8 \uC81C\uBAA9",
    example: "1-1. \uAC15\uC758 \uC18C\uAC1C",
    type: String
  })
], LessonDetailDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({ description: "\uC21C\uC11C", example: 1, type: Number })
], LessonDetailDto.prototype, "seq", 2);
__decorateClass([
  ApiProperty7({ description: "\uC0C1\uD0DC", example: import_parchment7.LESSON_STATE.NORMAL, enum: import_parchment7.LESSON_STATE })
], LessonDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty7({ description: "\uB808\uC2A8 \uC885\uB958", example: import_parchment7.LESSON_KIND.VIDEO, enum: import_parchment7.LESSON_KIND })
], LessonDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC2DC\uAC04",
    example: "10\uBD84 30\uCD08",
    nullable: true,
    type: String
  })
], LessonDetailDto.prototype, "duration", 2);
__decorateClass([
  ApiProperty7({
    description: "\uBBF8\uB9AC\uBCF4\uAE30 \uAC00\uB2A5 \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], LessonDetailDto.prototype, "isPreviewable", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], LessonDetailDto.prototype, "startAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], LessonDetailDto.prototype, "endAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uB808\uC2A8 \uB0B4\uC6A9",
    example: "\uAC15\uC758 \uB0B4\uC6A9\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  })
], LessonDetailDto.prototype, "content", 2);
__decorateClass([
  ApiProperty7({
    description: "\uB3D9\uC601\uC0C1 URL",
    example: "https://example.com/video.mp4",
    nullable: true,
    type: String
  })
], LessonDetailDto.prototype, "videoUrl", 2);
__decorateClass([
  ApiProperty7({
    description: "ZOOM \uD68C\uC758 URL",
    example: "https://zoom.us/j/123456789",
    nullable: true,
    type: String
  })
], LessonDetailDto.prototype, "joinUrl", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  })
], LessonDetailDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], LessonDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], LessonDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uCC55\uD130 \uC815\uBCF4",
    example: { id: 1, title: "1\uC7A5. \uC18C\uAC1C", seq: 1, state: "NORMAL" },
    type: Object
  })
], LessonDetailDto.prototype, "chapter", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC815\uBCF4",
    example: { id: 1, title: "React \uAE30\uCD08 \uAC15\uC758" },
    type: Object
  })
], LessonDetailDto.prototype, "course", 2);
var CreateCourseDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 \uC885\uB958", enum: import_parchment7.COURSE_KIND, example: import_parchment7.COURSE_KIND.WEBINAR }),
  IsEnum3(import_parchment7.COURSE_KIND),
  IsNotEmpty4()
], CreateCourseDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty7({ description: "\uCE74\uD14C\uACE0\uB9AC ID", example: 1, type: Number }),
  Type3(() => Number),
  IsInt3(),
  Min3(1),
  IsNotEmpty4()
], CreateCourseDto.prototype, "categoryId", 2);
__decorateClass([
  ApiProperty7({
    description: "\uAC15\uC758 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758",
    type: String
  }),
  IsString3(),
  IsNotEmpty4()
], CreateCourseDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC0AC ID", example: 1, type: Number }),
  Type3(() => Number),
  IsInt3(),
  Min3(1),
  IsNotEmpty4()
], CreateCourseDto.prototype, "instructorId", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC804\uCCB4 \uB808\uC2A8 \uC218 (\uC790\uB3D9 \uACC4\uC0B0\uB428, \uC785\uB825 \uBD88\uD544\uC694)",
    example: 0,
    minimum: 0,
    type: Number
  }),
  Type3(() => Number),
  IsInt3(),
  Min3(0),
  IsOptional3()
], CreateCourseDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB09C\uC774\uB3C4",
    enum: COURSE_LEVEL_VALUES,
    example: "\uCD08\uAE09",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.level !== null),
  IsEnum3(COURSE_LEVEL_VALUES)
], CreateCourseDto.prototype, "level", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.startAt !== null),
  IsDateString2()
], CreateCourseDto.prototype, "startAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.endAt !== null),
  IsDateString2()
], CreateCourseDto.prototype, "endAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC218\uAC15\uAD8C \uC720\uD6A8 \uAE30\uAC04 (\uC77C)",
    example: 30,
    nullable: true,
    type: Number
  }),
  IsOptional3(),
  ValidateIf((o) => o.periodDays !== null),
  Transform(({ value }) => {
    if (value === "" || value === void 0 || value === null) return null;
    return Number(value);
  }),
  IsInt3(),
  Min3(1)
], CreateCourseDto.prototype, "periodDays", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10\uC2DC\uAC04 30\uBD84",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.totalDuration !== null),
  IsString3()
], CreateCourseDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC0AC\uC804 \uC9C0\uC2DD",
    example: "JavaScript \uAE30\uCD08",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.preknowledge !== null),
  IsString3()
], CreateCourseDto.prototype, "preknowledge", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.materialsUrl !== null),
  IsString3()
], CreateCourseDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2A4\uD398\uC15C \uAC15\uC758 \uC5EC\uBD80",
    example: false,
    type: Boolean
  }),
  IsOptional3(),
  Transform(({ value }) => {
    if (value === "true" || value === true) return true;
    return false;
  }),
  IsBoolean()
], CreateCourseDto.prototype, "isSpecial", 2);
var UpdateCourseDto = class {
};
__decorateClass([
  ApiPropertyOptional4({ description: "\uAC15\uC758 \uC885\uB958", enum: import_parchment7.COURSE_KIND, example: import_parchment7.COURSE_KIND.WEBINAR }),
  IsOptional3(),
  IsEnum3(import_parchment7.COURSE_KIND)
], UpdateCourseDto.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional4({ description: "\uCE74\uD14C\uACE0\uB9AC ID", example: 1, type: Number }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], UpdateCourseDto.prototype, "categoryId", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758",
    type: String
  }),
  IsOptional3(),
  IsString3(),
  IsNotEmpty4()
], UpdateCourseDto.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({ description: "\uAC15\uC0AC ID", example: 1, type: Number }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], UpdateCourseDto.prototype, "instructorId", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC804\uCCB4 \uB808\uC2A8 \uC218",
    example: 10,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], UpdateCourseDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB09C\uC774\uB3C4",
    enum: COURSE_LEVEL_VALUES,
    example: "\uCD08\uAE09",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.level !== null),
  IsEnum3(COURSE_LEVEL_VALUES)
], UpdateCourseDto.prototype, "level", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.startAt !== null),
  IsDateString2()
], UpdateCourseDto.prototype, "startAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.endAt !== null),
  IsDateString2()
], UpdateCourseDto.prototype, "endAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC218\uAC15\uAD8C \uC720\uD6A8 \uAE30\uAC04 (\uC77C)",
    example: 30,
    nullable: true,
    type: Number
  }),
  IsOptional3(),
  ValidateIf((o) => o.periodDays !== null),
  Transform(({ value }) => {
    if (value === "" || value === void 0 || value === null) return null;
    return Number(value);
  }),
  IsInt3(),
  Min3(1)
], UpdateCourseDto.prototype, "periodDays", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC0AC\uC804 \uC9C0\uC2DD",
    example: "JavaScript \uAE30\uCD08",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.preknowledge !== null),
  IsString3()
], UpdateCourseDto.prototype, "preknowledge", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.materialsUrl !== null),
  IsString3()
], UpdateCourseDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2A4\uD398\uC15C \uAC15\uC758 \uC5EC\uBD80",
    example: false,
    type: Boolean
  }),
  IsOptional3(),
  Transform(({ value }) => {
    if (value === "true" || value === true) return true;
    return false;
  }),
  IsBoolean()
], UpdateCourseDto.prototype, "isSpecial", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC6D0\uAC00",
    example: 1e5,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(0)
], UpdateCourseDto.prototype, "originalPrice", 2);
var CreateChapterDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uCC55\uD130 \uC81C\uBAA9", example: "1\uC7A5. \uC18C\uAC1C", type: String }),
  IsString3(),
  IsNotEmpty4()
], CreateChapterDto.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C (\uBBF8\uC9C0\uC815 \uC2DC \uC790\uB3D9\uC73C\uB85C \uCD5C\uB300 seq + 1 \uC124\uC815)",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], CreateChapterDto.prototype, "seq", 2);
var ChapterResponseDto = class {
};
__decorateClass([
  ApiProperty7({ description: "\uCC55\uD130 ID", example: 1, type: Number })
], ChapterResponseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty7({ description: "\uCC55\uD130 \uC81C\uBAA9", example: "1\uC7A5. \uC18C\uAC1C", type: String })
], ChapterResponseDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({ description: "\uC21C\uC11C", example: 1, type: Number })
], ChapterResponseDto.prototype, "seq", 2);
__decorateClass([
  ApiProperty7({ description: "\uC0C1\uD0DC", example: import_parchment7.CHAPTER_STATE.NORMAL, type: String })
], ChapterResponseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty7({ description: "\uAC15\uC758 ID", example: 1, type: Number })
], ChapterResponseDto.prototype, "courseId", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ChapterResponseDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty7({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ChapterResponseDto.prototype, "updatedAt", 2);
var UpdateChapterDto = class {
};
__decorateClass([
  ApiPropertyOptional4({
    description: "\uCC55\uD130 \uC81C\uBAA9",
    example: "1\uC7A5. \uC18C\uAC1C",
    type: String
  }),
  IsOptional3(),
  IsString3(),
  IsNotEmpty4()
], UpdateChapterDto.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], UpdateChapterDto.prototype, "seq", 2);
var CreateLessonDto = class {
};
__decorateClass([
  ApiProperty7({
    description: "\uB808\uC2A8 \uC81C\uBAA9",
    example: "1-1. \uAC15\uC758 \uC18C\uAC1C",
    type: String
  }),
  IsString3(),
  IsNotEmpty4()
], CreateLessonDto.prototype, "title", 2);
__decorateClass([
  ApiProperty7({ description: "\uB808\uC2A8 \uC885\uB958", enum: import_parchment7.LESSON_KIND, example: import_parchment7.LESSON_KIND.VIDEO }),
  IsEnum3(import_parchment7.LESSON_KIND),
  IsNotEmpty4()
], CreateLessonDto.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C (\uBBF8\uC9C0\uC815 \uC2DC \uC790\uB3D9\uC73C\uB85C \uCD5C\uB300 seq + 1 \uC124\uC815)",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], CreateLessonDto.prototype, "seq", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB808\uC2A8 \uB0B4\uC6A9",
    example: "\uAC15\uC758 \uB0B4\uC6A9\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.content !== null),
  IsString3()
], CreateLessonDto.prototype, "content", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB3D9\uC601\uC0C1 URL",
    example: "https://example.com/video.mp4",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.videoUrl !== null),
  IsString3()
], CreateLessonDto.prototype, "videoUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "ZOOM \uD68C\uC758 URL",
    example: "https://zoom.us/j/123456789",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.joinUrl !== null),
  IsString3()
], CreateLessonDto.prototype, "joinUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.materialsUrl !== null),
  IsString3()
], CreateLessonDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.startAt !== null),
  IsDateString2()
], CreateLessonDto.prototype, "startAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.endAt !== null),
  IsDateString2()
], CreateLessonDto.prototype, "endAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uBBF8\uB9AC\uBCF4\uAE30 \uAC00\uB2A5 \uC5EC\uBD80",
    example: false,
    default: false,
    type: Boolean
  }),
  IsOptional3(),
  Transform(({ value }) => {
    if (value === "true") return true;
    else if (value === "false") return false;
    return value;
  }),
  IsBoolean()
], CreateLessonDto.prototype, "isPreviewable", 2);
var UpdateLessonDto = class {
};
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB808\uC2A8 \uC81C\uBAA9",
    example: "1-1. \uAC15\uC758 \uC18C\uAC1C",
    type: String
  }),
  IsOptional3(),
  IsString3(),
  IsNotEmpty4()
], UpdateLessonDto.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({ description: "\uB808\uC2A8 \uC885\uB958", enum: import_parchment7.LESSON_KIND, example: import_parchment7.LESSON_KIND.VIDEO }),
  IsOptional3(),
  IsEnum3(import_parchment7.LESSON_KIND)
], UpdateLessonDto.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], UpdateLessonDto.prototype, "seq", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB808\uC2A8 \uB0B4\uC6A9",
    example: "\uAC15\uC758 \uB0B4\uC6A9\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.content !== null),
  IsString3()
], UpdateLessonDto.prototype, "content", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB3D9\uC601\uC0C1 URL",
    example: "https://example.com/video.mp4",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.videoUrl !== null),
  IsString3()
], UpdateLessonDto.prototype, "videoUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "ZOOM \uD68C\uC758 URL",
    example: "https://zoom.us/j/123456789",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.joinUrl !== null),
  IsString3()
], UpdateLessonDto.prototype, "joinUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.materialsUrl !== null),
  IsString3()
], UpdateLessonDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.startAt !== null),
  IsDateString2()
], UpdateLessonDto.prototype, "startAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.endAt !== null),
  IsDateString2()
], UpdateLessonDto.prototype, "endAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uBBF8\uB9AC\uBCF4\uAE30 \uAC00\uB2A5 \uC5EC\uBD80",
    example: false,
    default: false,
    type: Boolean
  }),
  IsOptional3(),
  Transform(({ value }) => {
    if (value === "true") return true;
    else if (value === "false") return false;
    return value;
  }),
  IsBoolean()
], UpdateLessonDto.prototype, "isPreviewable", 2);
var BatchUpdateChapterItem = class {
};
__decorateClass([
  ApiProperty7({ description: "\uCC55\uD130 ID", example: 1, type: Number }),
  Type3(() => Number),
  IsInt3(),
  Min3(1),
  IsNotEmpty4()
], BatchUpdateChapterItem.prototype, "id", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uCC55\uD130 \uC81C\uBAA9",
    example: "1\uC7A5. \uC18C\uAC1C",
    type: String
  }),
  IsOptional3(),
  IsString3(),
  IsNotEmpty4()
], BatchUpdateChapterItem.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], BatchUpdateChapterItem.prototype, "seq", 2);
var BatchUpdateChaptersDto = class {
};
__decorateClass([
  ApiProperty7({
    description: "\uCC55\uD130 \uD56D\uBAA9 \uBC30\uC5F4",
    type: [BatchUpdateChapterItem],
    example: [
      { id: 1, seq: 3 },
      { id: 2, seq: 1 },
      { id: 3, seq: 2 }
    ]
  }),
  IsArray2(),
  ValidateNested2({ each: true }),
  Type3(() => BatchUpdateChapterItem),
  IsNotEmpty4()
], BatchUpdateChaptersDto.prototype, "items", 2);
var BatchUpdateLessonItem = class {
};
__decorateClass([
  ApiProperty7({ description: "\uB808\uC2A8 ID", example: 1, type: Number }),
  Type3(() => Number),
  IsInt3(),
  Min3(1),
  IsNotEmpty4()
], BatchUpdateLessonItem.prototype, "id", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB808\uC2A8 \uC81C\uBAA9",
    example: "1-1. \uAC15\uC758 \uC18C\uAC1C",
    type: String
  }),
  IsOptional3(),
  IsString3(),
  IsNotEmpty4()
], BatchUpdateLessonItem.prototype, "title", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC21C\uC11C",
    example: 1,
    minimum: 1,
    type: Number
  }),
  IsOptional3(),
  Type3(() => Number),
  IsInt3(),
  Min3(1)
], BatchUpdateLessonItem.prototype, "seq", 2);
__decorateClass([
  ApiPropertyOptional4({ description: "\uB808\uC2A8 \uC885\uB958", enum: import_parchment7.LESSON_KIND, example: import_parchment7.LESSON_KIND.VIDEO }),
  IsOptional3(),
  IsEnum3(import_parchment7.LESSON_KIND)
], BatchUpdateLessonItem.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB808\uC2A8 \uB0B4\uC6A9",
    example: "\uAC15\uC758 \uB0B4\uC6A9\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.content !== null),
  IsString3()
], BatchUpdateLessonItem.prototype, "content", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uB3D9\uC601\uC0C1 URL",
    example: "https://example.com/video.mp4",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.videoUrl !== null),
  IsString3()
], BatchUpdateLessonItem.prototype, "videoUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "ZOOM \uD68C\uC758 URL",
    example: "https://zoom.us/j/123456789",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.joinUrl !== null),
  IsString3()
], BatchUpdateLessonItem.prototype, "joinUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  }),
  IsOptional3(),
  ValidateIf((o) => o.materialsUrl !== null),
  IsString3()
], BatchUpdateLessonItem.prototype, "materialsUrl", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC2DC\uC791 \uC77C\uC2DC",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.startAt !== null),
  IsDateString2()
], BatchUpdateLessonItem.prototype, "startAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uC885\uB8CC \uC77C\uC2DC",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional3(),
  ValidateIf((o) => o.endAt !== null),
  IsDateString2()
], BatchUpdateLessonItem.prototype, "endAt", 2);
__decorateClass([
  ApiPropertyOptional4({
    description: "\uBBF8\uB9AC\uBCF4\uAE30 \uAC00\uB2A5 \uC5EC\uBD80",
    example: false,
    default: false,
    type: Boolean
  }),
  IsOptional3(),
  Transform(({ value }) => {
    if (value === "true") return true;
    else if (value === "false") return false;
    return value;
  }),
  IsBoolean()
], BatchUpdateLessonItem.prototype, "isPreviewable", 2);
var BatchUpdateLessonsDto = class {
};
__decorateClass([
  ApiProperty7({
    description: "\uB808\uC2A8 \uD56D\uBAA9 \uBC30\uC5F4",
    type: [BatchUpdateLessonItem],
    example: [
      { id: 10, seq: 2 },
      { id: 11, seq: 1 },
      { id: 12, seq: 3 }
    ]
  }),
  IsArray2(),
  ValidateNested2({ each: true }),
  Type3(() => BatchUpdateLessonItem),
  IsNotEmpty4()
], BatchUpdateLessonsDto.prototype, "items", 2);

// src/instructor.dto.ts
import { ApiProperty as ApiProperty8, ApiPropertyOptional as ApiPropertyOptional5 } from "@nestjs/swagger";
import { Type as Type4 } from "class-transformer";
import { IsOptional as IsOptional4, IsInt as IsInt4, Min as Min4, IsString as IsString4, IsEnum as IsEnum4, IsNotEmpty as IsNotEmpty5, ValidateIf as ValidateIf2 } from "class-validator";
var GetInstructorsParams = class {
};
__decorateClass([
  ApiPropertyOptional5({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional4(),
  Type4(() => Number),
  IsInt4(),
  Min4(1)
], GetInstructorsParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 20,
    minimum: 1,
    default: 20,
    type: Number
  }),
  IsOptional4(),
  Type4(() => Number),
  IsInt4(),
  Min4(1)
], GetInstructorsParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC815\uB82C \uAE30\uC900 \uD544\uB4DC",
    enum: ["createdAt", "updatedAt", "name"],
    example: "createdAt",
    default: "createdAt",
    type: String
  }),
  IsOptional4(),
  IsEnum4(["createdAt", "updatedAt", "name"])
], GetInstructorsParams.prototype, "sortBy", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC815\uB82C \uC21C\uC11C",
    enum: ["ASC", "DESC"],
    example: "DESC",
    default: "DESC",
    type: String
  }),
  IsOptional4(),
  IsEnum4(["ASC", "DESC"])
], GetInstructorsParams.prototype, "sortOrder", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uD544\uD130 \uD0A4",
    enum: ["search"],
    example: "search",
    type: String
  }),
  IsOptional4(),
  IsEnum4(["search"])
], GetInstructorsParams.prototype, "filterKey", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uD544\uD130 \uAC12 (\uAC80\uC0C9\uC5B4)",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  }),
  IsOptional4(),
  IsString4()
], GetInstructorsParams.prototype, "filterValue", 2);
var InstructorResponseDto = class {
};
__decorateClass([
  ApiProperty8({ description: "\uAC15\uC0AC ID", example: 1, type: Number })
], InstructorResponseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty8({ description: "\uC774\uB984", example: "\uD64D\uAE38\uB3D9", type: String })
], InstructorResponseDto.prototype, "name", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC9C1\uC5C5",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
    nullable: true,
    type: String
  })
], InstructorResponseDto.prototype, "occupation", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC18C\uAC1C \uC81C\uBAA9",
    example: "10\uB144\uCC28 \uAC1C\uBC1C\uC790",
    type: String
  })
], InstructorResponseDto.prototype, "bioTitle", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC18C\uAC1C \uB0B4\uC6A9",
    example: "React \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  })
], InstructorResponseDto.prototype, "bioContent", 2);
__decorateClass([
  ApiProperty8({
    description: "URL",
    example: "https://example.com",
    nullable: true,
    type: String
  })
], InstructorResponseDto.prototype, "url", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  })
], InstructorResponseDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC0C1\uD0DC",
    example: "NORMAL",
    type: String
  })
], InstructorResponseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], InstructorResponseDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], InstructorResponseDto.prototype, "updatedAt", 2);
var CreateInstructorDto = class {
};
__decorateClass([
  ApiProperty8({ description: "\uC774\uB984", example: "\uD64D\uAE38\uB3D9", type: String }),
  IsString4(),
  IsNotEmpty5()
], CreateInstructorDto.prototype, "name", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC9C1\uC5C5",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  IsString4()
], CreateInstructorDto.prototype, "occupation", 2);
__decorateClass([
  ApiProperty8({
    description: "\uC18C\uAC1C \uC81C\uBAA9",
    example: "10\uB144\uCC28 \uAC1C\uBC1C\uC790",
    type: String
  }),
  IsString4(),
  IsNotEmpty5()
], CreateInstructorDto.prototype, "bioTitle", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC18C\uAC1C \uB0B4\uC6A9",
    example: "React \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  IsString4()
], CreateInstructorDto.prototype, "bioContent", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "URL",
    example: "https://example.com",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  IsString4()
], CreateInstructorDto.prototype, "url", 2);
var UpdateInstructorDto = class {
};
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  }),
  IsOptional4(),
  IsString4(),
  IsNotEmpty5()
], UpdateInstructorDto.prototype, "name", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC9C1\uC5C5",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  ValidateIf2((o) => o.occupation !== null),
  IsString4()
], UpdateInstructorDto.prototype, "occupation", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC18C\uAC1C \uC81C\uBAA9",
    example: "10\uB144\uCC28 \uAC1C\uBC1C\uC790",
    type: String
  }),
  IsOptional4(),
  IsString4(),
  IsNotEmpty5()
], UpdateInstructorDto.prototype, "bioTitle", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uC18C\uAC1C \uB0B4\uC6A9",
    example: "React \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  ValidateIf2((o) => o.bioContent !== null),
  IsString4()
], UpdateInstructorDto.prototype, "bioContent", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "URL",
    example: "https://example.com",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  ValidateIf2((o) => o.url !== null),
  IsString4()
], UpdateInstructorDto.prototype, "url", 2);
__decorateClass([
  ApiPropertyOptional5({
    description: "\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 URL (null\uC774\uBA74 \uC774\uBBF8\uC9C0 \uC81C\uAC70)",
    nullable: true,
    type: String
  }),
  IsOptional4(),
  ValidateIf2((o) => o.imageUrl != null),
  IsString4()
], UpdateInstructorDto.prototype, "imageUrl", 2);
var GetInstructorsResponse = class {
};
__decorateClass([
  ApiProperty8({ description: "\uAC15\uC0AC \uBAA9\uB85D", type: [InstructorResponseDto] })
], GetInstructorsResponse.prototype, "data", 2);
__decorateClass([
  ApiProperty8({
    description: "\uD398\uC774\uC9C0\uB124\uC774\uC158 \uBA54\uD0C0 \uC815\uBCF4",
    example: {
      page: 1,
      limit: 20,
      total: 100,
      totalPages: 5,
      itemCount: 20
    },
    type: Object
  })
], GetInstructorsResponse.prototype, "meta", 2);

// src/product.dto.ts
var import_parchment8 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty9, ApiPropertyOptional as ApiPropertyOptional6 } from "@nestjs/swagger";
import { Type as Type5 } from "class-transformer";
import { IsOptional as IsOptional5, IsInt as IsInt5, Min as Min5, IsString as IsString5, IsEnum as IsEnum5, ValidateIf as ValidateIf3 } from "class-validator";
var PRODUCT_KIND_LABELS = {
  SINGLE: "\uB2E8\uC77C \uC0C1\uD488",
  COMPOSITE: "\uBCF5\uD569 \uC0C1\uD488",
  ROADMAP: "\uB85C\uB4DC\uB9F5"
};
var PRODUCT_STATE_LABELS = {
  NORMAL: "\uC815\uC0C1",
  HIDDEN: "\uC228\uAE40",
  DELETED: "\uC0AD\uC81C\uB428"
};
var PRODUCT_ITEM_STATE_LABELS = {
  NORMAL: "\uC815\uC0C1",
  DELETED: "\uC0AD\uC81C\uB428"
};
var ProductSortBy = /* @__PURE__ */ ((ProductSortBy2) => {
  ProductSortBy2["CREATED_AT"] = "createdAt";
  ProductSortBy2["UPDATED_AT"] = "updatedAt";
  ProductSortBy2["TITLE"] = "title";
  return ProductSortBy2;
})(ProductSortBy || {});
var ProductFilterKey = /* @__PURE__ */ ((ProductFilterKey2) => {
  ProductFilterKey2["SEARCH"] = "search";
  ProductFilterKey2["KIND"] = "kind";
  return ProductFilterKey2;
})(ProductFilterKey || {});
var PRODUCT_PACKAGE_KIND_LABELS = {
  REQUIREMENT: "\uD544\uC218",
  OPTION: "\uC120\uD0DD"
};
var PRODUCT_ITEM_KIND_LABELS = {
  COURSE: "\uAC15\uC758",
  GOODS: "\uD604\uBB3C \uC0C1\uD488"
};
var GetProductsParams = class {
  constructor() {
    this.page = 1;
    this.limit = 20;
    this.sortBy = "createdAt" /* CREATED_AT */;
    this.sortOrder = "DESC";
  }
};
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  IsInt5(),
  Min5(1)
], GetProductsParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 20,
    minimum: 1,
    default: 20,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  IsInt5(),
  Min5(1)
], GetProductsParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uC815\uB82C \uAE30\uC900 \uD544\uB4DC",
    enum: ProductSortBy,
    example: "createdAt" /* CREATED_AT */,
    default: "createdAt" /* CREATED_AT */,
    type: String
  }),
  IsOptional5(),
  IsEnum5(ProductSortBy)
], GetProductsParams.prototype, "sortBy", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uC815\uB82C \uC21C\uC11C (ASC: \uC624\uB984\uCC28\uC21C, DESC: \uB0B4\uB9BC\uCC28\uC21C)",
    enum: ["ASC", "DESC"],
    example: "DESC",
    default: "DESC",
    type: String
  }),
  IsOptional5(),
  IsEnum5(["ASC", "DESC"])
], GetProductsParams.prototype, "sortOrder", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD544\uD130 \uD0A4 (search: \uAC80\uC0C9(\uC81C\uBAA9/\uC124\uBA85), kind: \uC720\uD615)",
    enum: ProductFilterKey,
    example: "search" /* SEARCH */,
    type: String
  }),
  IsOptional5(),
  IsEnum5(ProductFilterKey)
], GetProductsParams.prototype, "filterKey", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD544\uD130 \uAC12 (filterKey\uC5D0 \uD574\uB2F9\uD558\uB294 \uAC12, kind\uC758 \uACBD\uC6B0 \uCF64\uB9C8\uB85C \uAD6C\uBD84\uD558\uC5EC \uC5EC\uB7EC \uAC12 \uC9C0\uC815 \uAC00\uB2A5)",
    example: "React",
    type: String,
    examples: {
      search: {
        value: "React",
        description: "\uC81C\uBAA9, \uC124\uBA85 \uAC80\uC0C9"
      },
      kind: {
        value: import_parchment8.PRODUCT_KIND.SINGLE,
        description: "\uC720\uD615 \uD544\uD130 (\uCF64\uB9C8\uB85C \uAD6C\uBD84\uD558\uC5EC \uC5EC\uB7EC \uAC12 \uC9C0\uC815 \uAC00\uB2A5)"
      }
    }
  }),
  IsOptional5(),
  IsString5()
], GetProductsParams.prototype, "filterValue", 2);
__decorateClass([
  ApiPropertyOptional6({ description: "\uC0C1\uD488 \uC720\uD615\uC73C\uB85C \uD544\uD130\uB9C1", example: import_parchment8.PRODUCT_KIND.SINGLE, enum: import_parchment8.PRODUCT_KIND }),
  IsOptional5(),
  IsEnum5(import_parchment8.PRODUCT_KIND)
], GetProductsParams.prototype, "kind", 2);
__decorateClass([
  ApiPropertyOptional6({ description: "\uC0C1\uD488 \uC0C1\uD0DC\uB85C \uD544\uD130\uB9C1", example: import_parchment8.PRODUCT_STATE.NORMAL, enum: import_parchment8.PRODUCT_STATE }),
  IsOptional5(),
  IsEnum5(import_parchment8.PRODUCT_STATE)
], GetProductsParams.prototype, "state", 2);
var ProductResponseDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 ID", example: 1, type: Number })
], ProductResponseDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758 \uD328\uD0A4\uC9C0",
    type: String
  })
], ProductResponseDto.prototype, "title", 2);
__decorateClass([
  ApiProperty9({
    description: "\uBD80\uC81C\uBAA9",
    example: "\uCD08\uBCF4\uC790\uB97C \uC704\uD55C React \uC785\uBB38",
    nullable: true,
    type: String
  })
], ProductResponseDto.prototype, "subtitle", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uACE0\uC720 \uC2DD\uBCC4\uC790",
    example: "react-basic-package",
    type: String
  })
], ProductResponseDto.prototype, "slug", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC124\uBA85",
    example: "React \uAE30\uCD08\uBD80\uD130 \uC2E4\uC804\uAE4C\uC9C0 \uBC30\uC6B0\uB294 \uD328\uD0A4\uC9C0",
    nullable: true,
    type: String
  })
], ProductResponseDto.prototype, "description", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC720\uD615", example: import_parchment8.PRODUCT_KIND.SINGLE, enum: import_parchment8.PRODUCT_KIND })
], ProductResponseDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_STATE.NORMAL, enum: import_parchment8.PRODUCT_STATE })
], ProductResponseDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC2DC\uC791 \uC2DC\uAC01",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductResponseDto.prototype, "openAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductResponseDto.prototype, "closeAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uB178\uCD9C \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductResponseDto.prototype, "displayEndAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10.5",
    nullable: true,
    type: String
  })
], ProductResponseDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC378\uB124\uC77C URL",
    example: "https://example.com/thumbnail.jpg",
    nullable: true,
    type: String
  })
], ProductResponseDto.prototype, "thumbnailUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  })
], ProductResponseDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductResponseDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductResponseDto.prototype, "updatedAt", 2);
var CategorySummaryDto = class {
};
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC ID",
    example: 1,
    nullable: true,
    type: Number
  })
], CategorySummaryDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC81C\uBAA9",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC",
    nullable: true,
    type: String
  })
], CategorySummaryDto.prototype, "title", 2);
var CategorySimpleDto = class {
};
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC ID",
    example: 1,
    nullable: true,
    type: Number
  })
], CategorySimpleDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC81C\uBAA9",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC",
    nullable: true,
    type: String
  })
], CategorySimpleDto.prototype, "title", 2);
var InstructorSummaryDto = class {
};
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC0AC ID",
    example: 1,
    nullable: true,
    type: Number
  })
], InstructorSummaryDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC0AC \uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    nullable: true,
    type: String
  })
], InstructorSummaryDto.prototype, "name", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC0AC \uC9C1\uC5C5",
    example: "\uD504\uB860\uD2B8\uC5D4\uB4DC \uAC1C\uBC1C\uC790",
    nullable: true,
    type: String
  })
], InstructorSummaryDto.prototype, "occupation", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC0AC \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  })
], InstructorSummaryDto.prototype, "imageUrl", 2);
var CourseSummaryDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uAC15\uC758 ID", example: 123, type: Number })
], CourseSummaryDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758",
    type: String
  })
], CourseSummaryDto.prototype, "title", 2);
__decorateClass([
  ApiProperty9({
    description: "\uB09C\uC774\uB3C4",
    example: "\uCD08\uAE09",
    nullable: true,
    type: String
  })
], CourseSummaryDto.prototype, "level", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 \uC885\uB958",
    example: import_parchment8.COURSE_KIND.WEBINAR,
    enum: import_parchment8.COURSE_KIND
  })
], CourseSummaryDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC804\uCCB4 \uB808\uC2A8 \uC218",
    example: 10,
    type: Number
  })
], CourseSummaryDto.prototype, "totalLessonCount", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10\uC2DC\uAC04 30\uBD84",
    nullable: true,
    type: String
  })
], CourseSummaryDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 \uC790\uB8CC URL",
    example: "https://example.com/material.pdf",
    nullable: true,
    type: String
  })
], CourseSummaryDto.prototype, "materialsUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC720\uB8CC \uD2B9\uAC15 \uC5EC\uBD80",
    example: false,
    type: Boolean
  })
], CourseSummaryDto.prototype, "isSpecial", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC378\uB124\uC77C URL",
    example: "https://example.com/thumbnail.jpg",
    nullable: true,
    type: String
  })
], CourseSummaryDto.prototype, "thumbnailUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C ID (\uAC15\uC758\uC5D0 \uC5F0\uACB0\uB41C product_item\uC758 id)",
    example: 1,
    nullable: true,
    type: Number
  })
], CourseSummaryDto.prototype, "productItemId", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC815\uBCF4",
    nullable: true,
    type: () => CategorySummaryDto
  })
], CourseSummaryDto.prototype, "category", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC0AC \uC815\uBCF4",
    nullable: true,
    type: () => InstructorSummaryDto
  })
], CourseSummaryDto.prototype, "instructor", 2);
var ProductItemDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC544\uC774\uD15C ID", example: 1, type: Number })
], ProductItemDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC544\uC774\uD15C \uC720\uD615", example: import_parchment8.PRODUCT_ITEM_KIND.COURSE, enum: import_parchment8.PRODUCT_ITEM_KIND })
], ProductItemDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_ITEM_STATE.NORMAL, enum: import_parchment8.PRODUCT_ITEM_STATE })
], ProductItemDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 ID",
    example: 1,
    nullable: true,
    type: Number
  })
], ProductItemDto.prototype, "courseId", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC ID",
    example: 1,
    nullable: true,
    type: Number
  })
], ProductItemDto.prototype, "categoryId", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC815\uBCF4",
    nullable: true,
    type: () => CategorySimpleDto
  })
], ProductItemDto.prototype, "category", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC6D0\uAC00",
    example: 1e5,
    type: Number
  })
], ProductItemDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC21C\uC11C",
    example: 1,
    type: Number
  })
], ProductItemDto.prototype, "seq", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD560\uC778 \uAE08\uC561",
    example: 1e4,
    type: Number
  })
], ProductItemDto.prototype, "discount", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductItemDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  }),
  ApiProperty9({
    description: "\uAC15\uC758 \uAC04\uB7B5 \uC815\uBCF4 (kind\uAC00 COURSE\uC778 \uACBD\uC6B0)",
    nullable: true,
    type: () => CourseSummaryDto
  })
], ProductItemDto.prototype, "course", 2);
var ProductItemDetailDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC544\uC774\uD15C ID", example: 1, type: Number })
], ProductItemDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC544\uC774\uD15C \uC720\uD615", example: import_parchment8.PRODUCT_ITEM_KIND.COURSE, enum: import_parchment8.PRODUCT_ITEM_KIND })
], ProductItemDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_ITEM_STATE.NORMAL, enum: import_parchment8.PRODUCT_ITEM_STATE })
], ProductItemDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 ID",
    example: 1,
    nullable: true,
    type: Number
  })
], ProductItemDetailDto.prototype, "courseId", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC ID",
    example: 1,
    nullable: true,
    type: Number
  })
], ProductItemDetailDto.prototype, "categoryId", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCE74\uD14C\uACE0\uB9AC \uC815\uBCF4",
    nullable: true,
    type: () => CategorySimpleDto
  })
], ProductItemDetailDto.prototype, "category", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC6D0\uAC00",
    example: 1e5,
    type: Number
  })
], ProductItemDetailDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD560\uC778 \uAE08\uC561",
    example: 1e4,
    type: Number
  })
], ProductItemDetailDto.prototype, "discount", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductItemDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductItemDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uAC15\uC758 \uAC04\uB7B5 \uC815\uBCF4 (kind\uAC00 COURSE\uC778 \uACBD\uC6B0)",
    nullable: true,
    type: () => CourseSummaryDto
  })
], ProductItemDetailDto.prototype, "course", 2);
var ProductDetailDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 ID", example: 1, type: Number })
], ProductDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758 \uD328\uD0A4\uC9C0",
    type: String
  })
], ProductDetailDto.prototype, "title", 2);
__decorateClass([
  ApiProperty9({
    description: "\uBD80\uC81C\uBAA9",
    example: "\uCD08\uBCF4\uC790\uB97C \uC704\uD55C React \uC785\uBB38",
    nullable: true,
    type: String
  })
], ProductDetailDto.prototype, "subtitle", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uACE0\uC720 \uC2DD\uBCC4\uC790",
    example: "react-basic-package",
    type: String
  })
], ProductDetailDto.prototype, "slug", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC124\uBA85",
    example: "React \uAE30\uCD08\uBD80\uD130 \uC2E4\uC804\uAE4C\uC9C0 \uBC30\uC6B0\uB294 \uD328\uD0A4\uC9C0",
    nullable: true,
    type: String
  })
], ProductDetailDto.prototype, "description", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC720\uD615", example: import_parchment8.PRODUCT_KIND.SINGLE, enum: import_parchment8.PRODUCT_KIND })
], ProductDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_STATE.NORMAL, enum: import_parchment8.PRODUCT_STATE })
], ProductDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC2DC\uC791 \uC2DC\uAC01",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductDetailDto.prototype, "openAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductDetailDto.prototype, "closeAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uB178\uCD9C \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  })
], ProductDetailDto.prototype, "displayEndAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uCD1D \uAC15\uC758 \uC2DC\uAC04",
    example: "10.5",
    nullable: true,
    type: String
  })
], ProductDetailDto.prototype, "totalDuration", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC378\uB124\uC77C URL",
    example: "https://example.com/thumbnail.jpg",
    nullable: true,
    type: String
  })
], ProductDetailDto.prototype, "thumbnailUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  })
], ProductDetailDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0DD\uC131\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC218\uC815\uC77C",
    example: "2024-01-01T10:00:00Z",
    type: String,
    format: "date-time"
  })
], ProductDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C \uBAA9\uB85D",
    type: [ProductItemDto]
  })
], ProductDetailDto.prototype, "items", 2);
var ProductItemConnectionDto = class {
};
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC544\uC774\uD15C ID", example: 1, type: Number }),
  IsInt5(),
  Min5(1)
], ProductItemConnectionDto.prototype, "productItemId", 2);
__decorateClass([
  ApiProperty9({ description: "\uC21C\uC11C", example: 1, type: Number }),
  IsInt5(),
  Min5(1)
], ProductItemConnectionDto.prototype, "seq", 2);
__decorateClass([
  ApiProperty9({ description: "\uD560\uC778 \uAE08\uC561", example: 0, type: Number }),
  IsInt5(),
  Min5(0)
], ProductItemConnectionDto.prototype, "discount", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uC0C1\uD488 \uD328\uD0A4\uC9C0 \uC720\uD615 (REQUIREMENT: \uD544\uC218, OPTION: \uC120\uD0DD)",
    enum: import_parchment8.PRODUCT_PACKAGE_KIND,
    example: import_parchment8.PRODUCT_PACKAGE_KIND.REQUIREMENT,
    default: import_parchment8.PRODUCT_PACKAGE_KIND.REQUIREMENT
  }),
  IsOptional5(),
  IsEnum5(import_parchment8.PRODUCT_PACKAGE_KIND)
], ProductItemConnectionDto.prototype, "kind", 2);
var CreateProductDto = class {
};
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758 \uD328\uD0A4\uC9C0",
    type: String
  }),
  IsString5()
], CreateProductDto.prototype, "title", 2);
__decorateClass([
  ApiProperty9({
    description: "\uBD80\uC81C\uBAA9",
    example: "\uCD08\uBCF4\uC790\uB97C \uC704\uD55C React \uC785\uBB38",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  ValidateIf3((o) => o.subtitle !== null),
  IsString5()
], CreateProductDto.prototype, "subtitle", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uACE0\uC720 \uC2DD\uBCC4\uC790",
    example: "react-basic-package",
    type: String
  }),
  IsString5()
], CreateProductDto.prototype, "slug", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC124\uBA85",
    example: "React \uAE30\uCD08\uBD80\uD130 \uC2E4\uC804\uAE4C\uC9C0 \uBC30\uC6B0\uB294 \uD328\uD0A4\uC9C0",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], CreateProductDto.prototype, "description", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC720\uD615", example: import_parchment8.PRODUCT_KIND.SINGLE, enum: import_parchment8.PRODUCT_KIND }),
  IsEnum5(import_parchment8.PRODUCT_KIND)
], CreateProductDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_STATE.NORMAL, enum: import_parchment8.PRODUCT_STATE }),
  IsEnum5(import_parchment8.PRODUCT_STATE)
], CreateProductDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC2DC\uC791 \uC2DC\uAC01",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], CreateProductDto.prototype, "openAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], CreateProductDto.prototype, "closeAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uB178\uCD9C \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], CreateProductDto.prototype, "displayEndAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC378\uB124\uC77C URL",
    example: "https://example.com/thumbnail.jpg",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], CreateProductDto.prototype, "thumbnailUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], CreateProductDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C \uBAA9\uB85D (\uD328\uD0A4\uC9C0 \uC0C1\uD488\uC778 \uACBD\uC6B0)",
    type: [ProductItemConnectionDto],
    nullable: true
  }),
  IsOptional5(),
  Type5(() => ProductItemConnectionDto)
], CreateProductDto.prototype, "items", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C ID (\uB2E8\uC77C \uC0C1\uD488\uC778 \uACBD\uC6B0)",
    example: 1,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  ValidateIf3((o) => {
    const value = o.productItemId;
    if (value === void 0 || value === null) {
      return false;
    }
    const numValue = Number(value);
    return !isNaN(numValue) && numValue > 0 && Number.isInteger(numValue);
  }),
  IsInt5(),
  Min5(1)
], CreateProductDto.prototype, "productItemId", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD560\uC778 \uAE08\uC561",
    example: 0,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  IsInt5(),
  Min5(0)
], CreateProductDto.prototype, "discount", 2);
var UpdateProductDto = class {
};
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC81C\uBAA9",
    example: "React \uAE30\uCD08 \uAC15\uC758 \uD328\uD0A4\uC9C0",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], UpdateProductDto.prototype, "title", 2);
__decorateClass([
  ApiProperty9({
    description: "\uBD80\uC81C\uBAA9",
    example: "\uCD08\uBCF4\uC790\uB97C \uC704\uD55C React \uC785\uBB38",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  ValidateIf3((o) => o.subtitle !== null),
  IsString5()
], UpdateProductDto.prototype, "subtitle", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uACE0\uC720 \uC2DD\uBCC4\uC790",
    example: "react-basic-package",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], UpdateProductDto.prototype, "slug", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC124\uBA85",
    example: "React \uAE30\uCD08\uBD80\uD130 \uC2E4\uC804\uAE4C\uC9C0 \uBC30\uC6B0\uB294 \uD328\uD0A4\uC9C0",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], UpdateProductDto.prototype, "description", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD488 \uC720\uD615", example: import_parchment8.PRODUCT_KIND.SINGLE, enum: import_parchment8.PRODUCT_KIND, nullable: true }),
  IsOptional5(),
  IsEnum5(import_parchment8.PRODUCT_KIND)
], UpdateProductDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty9({ description: "\uC0C1\uD0DC", example: import_parchment8.PRODUCT_STATE.NORMAL, enum: import_parchment8.PRODUCT_STATE, nullable: true }),
  IsOptional5(),
  IsEnum5(import_parchment8.PRODUCT_STATE)
], UpdateProductDto.prototype, "state", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC2DC\uC791 \uC2DC\uAC01",
    example: "2024-01-01T10:00:00Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], UpdateProductDto.prototype, "openAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uD310\uB9E4 \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], UpdateProductDto.prototype, "closeAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uB178\uCD9C \uC885\uB8CC \uC2DC\uAC01",
    example: "2024-12-31T23:59:59Z",
    nullable: true,
    type: String,
    format: "date-time"
  }),
  IsOptional5(),
  Type5(() => Date)
], UpdateProductDto.prototype, "displayEndAt", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC378\uB124\uC77C URL",
    example: "https://example.com/thumbnail.jpg",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], UpdateProductDto.prototype, "thumbnailUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.jpg",
    nullable: true,
    type: String
  }),
  IsOptional5(),
  IsString5()
], UpdateProductDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty9({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C \uBAA9\uB85D",
    type: [ProductItemConnectionDto],
    nullable: true
  }),
  IsOptional5(),
  Type5(() => ProductItemConnectionDto)
], UpdateProductDto.prototype, "items", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uC0C1\uD488 \uC544\uC774\uD15C ID (\uB2E8\uC77C \uC0C1\uD488\uC778 \uACBD\uC6B0)",
    example: 1,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  IsInt5(),
  Min5(1)
], UpdateProductDto.prototype, "productItemId", 2);
__decorateClass([
  ApiPropertyOptional6({
    description: "\uD560\uC778 \uAE08\uC561",
    example: 0,
    type: Number
  }),
  IsOptional5(),
  Type5(() => Number),
  IsInt5(),
  Min5(0)
], UpdateProductDto.prototype, "discount", 2);

// src/payment.dto.ts
var import_parchment9 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty10, ApiPropertyOptional as ApiPropertyOptional7 } from "@nestjs/swagger";
import { Type as Type6 } from "class-transformer";
import { IsEnum as IsEnum6, IsInt as IsInt6, IsOptional as IsOptional6, IsString as IsString6, Min as Min6 } from "class-validator";
var PaymentSortBy = /* @__PURE__ */ ((PaymentSortBy2) => {
  PaymentSortBy2["CREATED_AT"] = "createdAt";
  PaymentSortBy2["AMOUNT"] = "amount";
  return PaymentSortBy2;
})(PaymentSortBy || {});
var PaymentFilterKey = /* @__PURE__ */ ((PaymentFilterKey2) => {
  PaymentFilterKey2["SEARCH"] = "search";
  PaymentFilterKey2["STATE"] = "state";
  PaymentFilterKey2["METHOD"] = "method";
  return PaymentFilterKey2;
})(PaymentFilterKey || {});
var PAYMENT_STATE_LABELS = {
  READY: "\uB300\uAE30",
  PROCESSING: "\uC9C4\uD589 \uC911",
  SUCCEEDED: "\uACB0\uC81C \uC644\uB8CC",
  FAILED: "\uC2E4\uD328"
};
var PAYMENT_STATE_BADGE_VARIANT = {
  READY: "neutral",
  PROCESSING: "primary",
  SUCCEEDED: "success",
  FAILED: "danger"
};
var GetPaymentsParams = class {
  constructor() {
    this.page = 1;
    this.limit = 20;
    this.sortBy = "createdAt" /* CREATED_AT */;
    this.sortOrder = "DESC";
  }
};
__decorateClass([
  ApiPropertyOptional7({
    description: "\uD398\uC774\uC9C0 \uBC88\uD638",
    example: 1,
    minimum: 1,
    default: 1,
    type: Number
  }),
  IsOptional6(),
  Type6(() => Number),
  IsInt6(),
  Min6(1)
], GetPaymentsParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218",
    example: 20,
    minimum: 1,
    default: 20,
    type: Number
  }),
  IsOptional6(),
  Type6(() => Number),
  IsInt6(),
  Min6(1)
], GetPaymentsParams.prototype, "limit", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uC815\uB82C \uAE30\uC900",
    enum: PaymentSortBy,
    example: "createdAt" /* CREATED_AT */,
    default: "createdAt" /* CREATED_AT */
  }),
  IsOptional6(),
  IsEnum6(PaymentSortBy)
], GetPaymentsParams.prototype, "sortBy", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uC815\uB82C \uC21C\uC11C",
    enum: ["ASC", "DESC"],
    example: "DESC",
    default: "DESC"
  }),
  IsOptional6(),
  IsEnum6(["ASC", "DESC"])
], GetPaymentsParams.prototype, "sortOrder", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uD544\uD130 \uD0A4 (search: \uC774\uBA54\uC77C/\uC8FC\uBB38\uBC88\uD638 \uAC80\uC0C9, state: \uACB0\uC81C \uC0C1\uD0DC, method: \uACB0\uC81C \uC218\uB2E8)",
    enum: PaymentFilterKey,
    example: "search" /* SEARCH */
  }),
  IsOptional6(),
  IsEnum6(PaymentFilterKey)
], GetPaymentsParams.prototype, "filterKey", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uD544\uD130 \uAC12",
    example: "user@example.com"
  }),
  IsOptional6(),
  IsString6()
], GetPaymentsParams.prototype, "filterValue", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uACC4\uC815 ID\uB85C \uD544\uD130\uB9C1 (\uD2B9\uC815 \uC0AC\uC6A9\uC790\uC758 \uACB0\uC81C \uB0B4\uC5ED \uC870\uD68C)",
    example: 1,
    type: Number
  }),
  IsOptional6(),
  Type6(() => Number),
  IsInt6(),
  Min6(1)
], GetPaymentsParams.prototype, "accountId", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uC870\uD68C \uC2DC\uC791\uC77C (YYYY-MM-DD). endDate \uC5C6\uC774 \uC0AC\uC6A9 \uC2DC \uC624\uB298\uAE4C\uC9C0 \uC870\uD68C. endDate\uB9CC \uC788\uC73C\uBA74 \uBB34\uC2DC",
    example: "2025-01-01",
    type: String
  }),
  IsOptional6(),
  IsString6()
], GetPaymentsParams.prototype, "startDate", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uC870\uD68C \uC885\uB8CC\uC77C (YYYY-MM-DD). startDate \uC5C6\uC774 \uC0AC\uC6A9 \uC2DC \uD544\uD130 \uBB34\uC2DC",
    example: "2025-02-23",
    type: String
  }),
  IsOptional6(),
  IsString6()
], GetPaymentsParams.prototype, "endDate", 2);
__decorateClass([
  ApiPropertyOptional7({ description: "\uACB0\uC81C \uC0C1\uD0DC\uB85C \uD544\uD130\uB9C1", example: import_parchment9.PAYMENT_STATE.SUCCEEDED, enum: import_parchment9.PAYMENT_STATE }),
  IsOptional6(),
  IsEnum6(import_parchment9.PAYMENT_STATE)
], GetPaymentsParams.prototype, "state", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uACB0\uC81C \uC218\uB2E8\uC73C\uB85C \uD544\uD130\uB9C1 (\uC608: CARD, VBANK \uB4F1)",
    example: "CARD",
    type: String
  }),
  IsOptional6(),
  IsEnum6(import_parchment9.PAYMENT_METHOD)
], GetPaymentsParams.prototype, "method", 2);
var PaymentSummaryDto = class {
};
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C ID", example: 1, type: Number })
], PaymentSummaryDto.prototype, "id", 2);
__decorateClass([
  ApiProperty10({ description: "\uC8FC\uBB38\uC11C ID", example: 1001, type: Number })
], PaymentSummaryDto.prototype, "orderSheetId", 2);
__decorateClass([
  ApiProperty10({
    description: "\uAD6C\uB9E4\uC790 \uC774\uBA54\uC77C",
    example: "user@example.com",
    type: String
  })
], PaymentSummaryDto.prototype, "buyerEmail", 2);
__decorateClass([
  ApiProperty10({
    description: "\uAD6C\uB9E4\uC790 \uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  })
], PaymentSummaryDto.prototype, "buyerName", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC8FC\uBB38 \uC81C\uBAA9 (order_sheet.title). \uC0C1\uC138 \uC870\uD68C\uC758 \uAC1C\uBCC4 \uC0C1\uD488\uBA85\uC740 order_product.title\uC744 \uC0AC\uC6A9\uD558\uBBC0\uB85C \uAC12\uC774 \uB2E4\uB97C \uC218 \uC788\uC74C",
    example: "AI \uC785\uBB38 \uAC15\uC758",
    type: String
  })
], PaymentSummaryDto.prototype, "orderTitle", 2);
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C \uC0C1\uD0DC", example: import_parchment9.PAYMENT_STATE.SUCCEEDED, enum: import_parchment9.PAYMENT_STATE })
], PaymentSummaryDto.prototype, "state", 2);
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C \uC218\uB2E8", example: import_parchment9.PAYMENT_METHOD.CARD, enum: import_parchment9.PAYMENT_METHOD })
], PaymentSummaryDto.prototype, "method", 2);
__decorateClass([
  ApiProperty10({
    description: "\uACB0\uC81C \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], PaymentSummaryDto.prototype, "amount", 2);
__decorateClass([
  ApiProperty10({
    description: "\uACB0\uC81C \uC2DC\uAC01",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], PaymentSummaryDto.prototype, "createdAt", 2);
var PaymentProductSummaryDto = class {
};
__decorateClass([
  ApiProperty10({ description: "\uC0C1\uD488 ID", example: 101, type: Number })
], PaymentProductSummaryDto.prototype, "productId", 2);
__decorateClass([
  ApiProperty10({ description: "\uC0C1\uD488 \uC81C\uBAA9", example: "AI \uC785\uBB38 \uAC15\uC758", type: String })
], PaymentProductSummaryDto.prototype, "title", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC0C1\uD488 \uC2AC\uB7EC\uADF8",
    example: "intro-to-ai",
    type: String
  })
], PaymentProductSummaryDto.prototype, "slug", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC0C1\uD488 \uB300\uD45C \uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.png",
    type: String,
    nullable: true
  })
], PaymentProductSummaryDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC0C1\uD488 \uC6D0\uAC00",
    example: 5e4,
    type: Number
  })
], PaymentProductSummaryDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC0C1\uD488 \uD560\uC778 \uAE08\uC561",
    example: 1e4,
    type: Number
  })
], PaymentProductSummaryDto.prototype, "discount", 2);
var PaymentDetailDto = class {
};
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C ID", example: 1, type: Number })
], PaymentDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C \uC0C1\uD0DC", example: import_parchment9.PAYMENT_STATE.SUCCEEDED, enum: import_parchment9.PAYMENT_STATE })
], PaymentDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty10({ description: "\uACB0\uC81C \uC218\uB2E8", example: import_parchment9.PAYMENT_METHOD.CARD, enum: import_parchment9.PAYMENT_METHOD })
], PaymentDetailDto.prototype, "method", 2);
__decorateClass([
  ApiProperty10({
    description: "\uACB0\uC81C \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], PaymentDetailDto.prototype, "amount", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC2B9\uC778 \uBC88\uD638",
    example: "12345678",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "applyNum", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC601\uC218\uC99D URL",
    example: "https://pg.example.com/receipt/xxx",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "receiptUrl", 2);
__decorateClass([
  ApiProperty10({
    description: "PG\uC0AC \uAD6C\uBD84 \uCF54\uB4DC",
    example: "html5_inicis",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "pgProvider", 2);
__decorateClass([
  ApiProperty10({
    description: "PG \uAC70\uB798 \uBC88\uD638",
    example: "PGTID123456",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "pgTid", 2);
__decorateClass([
  ApiProperty10({
    description: "\uD3EC\uD2B8\uC6D0 \uAC70\uB798\uBC88\uD638(imp_uid)",
    example: "imp_123456789",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "impUid", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uCDE8\uC18C \uC0AC\uC720",
    example: "\uACE0\uAC1D \uC694\uCCAD",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "cancelReason", 2);
__decorateClass([
  ApiPropertyOptional7({
    description: "\uC2E4\uD328 \uC0AC\uC720",
    example: "\uCE74\uB4DC \uD55C\uB3C4 \uCD08\uACFC",
    type: String,
    nullable: true
  })
], PaymentDetailDto.prototype, "failureReason", 2);
__decorateClass([
  ApiProperty10({
    description: "\uACB0\uC81C \uC0DD\uC131 \uC2DC\uAC01",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], PaymentDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty10({ description: "\uC8FC\uBB38\uC11C ID", example: 1001, type: Number })
], PaymentDetailDto.prototype, "orderSheetId", 2);
__decorateClass([
  ApiProperty10({ description: "\uC8FC\uBB38\uC11C \uC0C1\uD0DC", example: import_parchment9.ORDER_SHEET_STATE.PAID, enum: import_parchment9.ORDER_SHEET_STATE })
], PaymentDetailDto.prototype, "orderSheetState", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC8FC\uBB38 \uC81C\uBAA9",
    example: "AI \uC785\uBB38 \uAC15\uC758 \uC678 2\uAC74",
    type: String
  })
], PaymentDetailDto.prototype, "orderTitle", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC8FC\uBB38 \uC0DD\uC131 \uC2DC\uAC01",
    example: "2025-12-03T09:59:00Z",
    type: String,
    format: "date-time"
  })
], PaymentDetailDto.prototype, "orderCreatedAt", 2);
__decorateClass([
  ApiProperty10({
    description: "\uAD6C\uB9E4\uC790 \uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  })
], PaymentDetailDto.prototype, "buyerName", 2);
__decorateClass([
  ApiProperty10({
    description: "\uAD6C\uB9E4\uC790 \uC774\uBA54\uC77C",
    example: "user@example.com",
    type: String
  })
], PaymentDetailDto.prototype, "buyerEmail", 2);
__decorateClass([
  ApiProperty10({
    description: "\uAD6C\uB9E4\uC790 \uC804\uD654\uBC88\uD638",
    example: "010-1234-5678",
    type: String
  })
], PaymentDetailDto.prototype, "buyerPhone", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC804\uCCB4 \uC6D0\uAC00",
    example: 12e4,
    type: Number
  })
], PaymentDetailDto.prototype, "orderOriginalPrice", 2);
__decorateClass([
  ApiProperty10({
    description: "\uC804\uCCB4 \uD560\uC778 \uAE08\uC561",
    example: 3e4,
    type: Number
  })
], PaymentDetailDto.prototype, "orderDiscount", 2);
__decorateClass([
  ApiProperty10({
    description: "\uCD5C\uC885 \uACB0\uC81C \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], PaymentDetailDto.prototype, "orderFinalPrice", 2);
__decorateClass([
  ApiProperty10({
    description: "\uD574\uB2F9 \uACB0\uC81C\uB85C \uAD6C\uB9E4\uB41C \uC0C1\uD488 \uBAA9\uB85D",
    type: () => [PaymentProductSummaryDto]
  })
], PaymentDetailDto.prototype, "products", 2);

// src/order-sheet.dto.ts
var import_parchment10 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty11, ApiPropertyOptional as ApiPropertyOptional8 } from "@nestjs/swagger";
var OrderTransactionSummaryDto = class {
};
__decorateClass([
  ApiProperty11({ description: "\uC8FC\uBB38 \uCC98\uB9AC ID", example: 1, type: Number })
], OrderTransactionSummaryDto.prototype, "id", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uCC98\uB9AC \uC0C1\uD0DC",
    example: import_parchment10.ORDER_TRANSACTION_STATE.SUCCEEDED,
    enum: import_parchment10.ORDER_TRANSACTION_STATE
  })
], OrderTransactionSummaryDto.prototype, "state", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uCC98\uB9AC \uC720\uD615",
    example: import_parchment10.ORDER_TRANSACTION_KIND.PAYMENT,
    enum: import_parchment10.ORDER_TRANSACTION_KIND
  })
], OrderTransactionSummaryDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty11({
    description: "\uCC98\uB9AC \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], OrderTransactionSummaryDto.prototype, "amount", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC0DD\uC131\uC77C\uC2DC",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], OrderTransactionSummaryDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty11({
    description: "\uCD5C\uC885 \uC218\uC815\uC77C\uC2DC",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], OrderTransactionSummaryDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uC6D0 \uC8FC\uBB38 \uCC98\uB9AC ID (\uD658\uBD88/\uCDE8\uC18C \uC2DC)",
    example: 1,
    type: Number,
    nullable: true
  })
], OrderTransactionSummaryDto.prototype, "baseOrderTransactionId", 2);
var OrderTransactionPaymentDto = class {
};
__decorateClass([
  ApiProperty11({ description: "\uACB0\uC81C ID", example: 1, type: Number })
], OrderTransactionPaymentDto.prototype, "id", 2);
__decorateClass([
  ApiProperty11({ description: "\uACB0\uC81C \uC0C1\uD0DC", example: import_parchment10.PAYMENT_STATE.SUCCEEDED, enum: import_parchment10.PAYMENT_STATE })
], OrderTransactionPaymentDto.prototype, "state", 2);
__decorateClass([
  ApiProperty11({ description: "\uACB0\uC81C \uC218\uB2E8", example: import_parchment10.PAYMENT_METHOD.CARD, enum: import_parchment10.PAYMENT_METHOD })
], OrderTransactionPaymentDto.prototype, "method", 2);
__decorateClass([
  ApiProperty11({
    description: "\uACB0\uC81C \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], OrderTransactionPaymentDto.prototype, "amount", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uC2B9\uC778 \uBC88\uD638",
    example: "12345678",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "applyNum", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uC601\uC218\uC99D URL",
    example: "https://pg.example.com/receipt/xxx",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "receiptUrl", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uD3EC\uD2B8\uC6D0 \uAC70\uB798\uBC88\uD638",
    example: "imp_123456789",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "impUid", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "PG\uC0AC \uAD6C\uBD84 \uCF54\uB4DC",
    example: "html5_inicis",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "pgProvider", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "PG \uAC70\uB798 \uBC88\uD638",
    example: "PGTID123456",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "pgTid", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uCFE0\uD3F0 ID",
    example: 1,
    type: Number,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "couponId", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uCDE8\uC18C \uC0AC\uC720",
    example: "\uACE0\uAC1D \uC694\uCCAD",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "cancelReason", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uC2E4\uD328 \uC0AC\uC720",
    example: "\uCE74\uB4DC \uD55C\uB3C4 \uCD08\uACFC",
    type: String,
    nullable: true
  })
], OrderTransactionPaymentDto.prototype, "failureReason", 2);
__decorateClass([
  ApiProperty11({
    description: "\uACB0\uC81C \uC0DD\uC131 \uC2DC\uAC01",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], OrderTransactionPaymentDto.prototype, "createdAt", 2);
var OrderTransactionProductDto = class {
};
__decorateClass([
  ApiProperty11({ description: "\uC8FC\uBB38 \uC0C1\uD488 ID", example: 1, type: Number })
], OrderTransactionProductDto.prototype, "id", 2);
__decorateClass([
  ApiProperty11({ description: "\uC0C1\uD488 ID", example: 101, type: Number })
], OrderTransactionProductDto.prototype, "productId", 2);
__decorateClass([
  ApiProperty11({ description: "\uC0C1\uD488 \uC81C\uBAA9", example: "AI \uC785\uBB38 \uAC15\uC758", type: String })
], OrderTransactionProductDto.prototype, "title", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC0C1\uD488 \uC2AC\uB7EC\uADF8",
    example: "intro-to-ai",
    type: String
  })
], OrderTransactionProductDto.prototype, "slug", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "\uC0C1\uD488 \uB300\uD45C \uC774\uBBF8\uC9C0 URL",
    example: "https://example.com/image.png",
    type: String,
    nullable: true
  })
], OrderTransactionProductDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC0C1\uD488 \uC6D0\uAC00",
    example: 5e4,
    type: Number
  })
], OrderTransactionProductDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC0C1\uD488 \uD560\uC778 \uAE08\uC561",
    example: 1e4,
    type: Number
  })
], OrderTransactionProductDto.prototype, "discount", 2);
__decorateClass([
  ApiProperty11({ description: "\uC0C1\uD488 \uC0C1\uD0DC", example: import_parchment10.ORDER_PRODUCT_STATE.NORMAL, enum: import_parchment10.ORDER_PRODUCT_STATE })
], OrderTransactionProductDto.prototype, "state", 2);
var OrderTransactionDetailDto = class extends OrderTransactionSummaryDto {
};
__decorateClass([
  ApiProperty11({
    description: "\uD574\uB2F9 \uC8FC\uBB38 \uCC98\uB9AC\uC5D0 \uC5F0\uACB0\uB41C \uACB0\uC81C \uBAA9\uB85D",
    type: () => [OrderTransactionPaymentDto]
  })
], OrderTransactionDetailDto.prototype, "payments", 2);
__decorateClass([
  ApiProperty11({
    description: "\uD574\uB2F9 \uC8FC\uBB38 \uCC98\uB9AC\uC5D0 \uD3EC\uD568\uB41C \uC0C1\uD488 \uBAA9\uB85D",
    type: () => [OrderTransactionProductDto]
  })
], OrderTransactionDetailDto.prototype, "products", 2);
var OrderSheetDetailDto = class {
};
__decorateClass([
  ApiProperty11({ description: "\uC8FC\uBB38\uC11C ID", example: 1001, type: Number })
], OrderSheetDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty11({ description: "\uC8FC\uBB38 \uC0C1\uD0DC", example: import_parchment10.ORDER_SHEET_STATE.ORDERED, enum: import_parchment10.ORDER_SHEET_STATE })
], OrderSheetDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uC81C\uBAA9",
    example: "AI \uC785\uBB38 \uAC15\uC758 \uC678 2\uAC74",
    type: String
  })
], OrderSheetDetailDto.prototype, "title", 2);
__decorateClass([
  ApiProperty11({
    description: "\uCCB4\uD06C\uC544\uC6C3 ID",
    example: "550e8400-e29b-41d4-a716-446655440000",
    type: String
  })
], OrderSheetDetailDto.prototype, "checkoutId", 2);
__decorateClass([
  ApiPropertyOptional8({
    description: "PG\uC6A9 \uC790\uCCB4 \uC8FC\uBB38 ID",
    example: "merchant_123456",
    type: String,
    nullable: true
  })
], OrderSheetDetailDto.prototype, "merchantUid", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uACC4\uC815 ID",
    example: 1,
    type: Number
  })
], OrderSheetDetailDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uC0DD\uC131 \uC2DC\uAC01",
    example: "2025-12-03T09:59:00Z",
    type: String,
    format: "date-time"
  })
], OrderSheetDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty11({
    description: "\uCD5C\uC885 \uC218\uC815 \uC2DC\uAC01",
    example: "2025-12-03T10:00:00Z",
    type: String,
    format: "date-time"
  })
], OrderSheetDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty11({
    description: "\uAD6C\uB9E4\uC790 \uC774\uB984",
    example: "\uD64D\uAE38\uB3D9",
    type: String
  })
], OrderSheetDetailDto.prototype, "buyerName", 2);
__decorateClass([
  ApiProperty11({
    description: "\uAD6C\uB9E4\uC790 \uC774\uBA54\uC77C",
    example: "user@example.com",
    type: String
  })
], OrderSheetDetailDto.prototype, "buyerEmail", 2);
__decorateClass([
  ApiProperty11({
    description: "\uAD6C\uB9E4\uC790 \uC804\uD654\uBC88\uD638",
    example: "010-1234-5678",
    type: String
  })
], OrderSheetDetailDto.prototype, "buyerPhone", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC804\uCCB4 \uC6D0\uAC00",
    example: 12e4,
    type: Number
  })
], OrderSheetDetailDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC804\uCCB4 \uD560\uC778 \uAE08\uC561",
    example: 3e4,
    type: Number
  })
], OrderSheetDetailDto.prototype, "discount", 2);
__decorateClass([
  ApiProperty11({
    description: "\uCD5C\uC885 \uC8FC\uBB38 \uAE08\uC561",
    example: 9e4,
    type: Number
  })
], OrderSheetDetailDto.prototype, "finalPrice", 2);
__decorateClass([
  ApiProperty11({
    description: "\uC8FC\uBB38 \uCC98\uB9AC \uBAA9\uB85D",
    type: () => [OrderTransactionDetailDto]
  })
], OrderSheetDetailDto.prototype, "transactions", 2);

// src/delivery.dto.ts
var import_parchment11 = __toESM(require_dist(), 1);
import { ApiProperty as ApiProperty12, ApiPropertyOptional as ApiPropertyOptional9 } from "@nestjs/swagger";
import { Type as Type7 } from "class-transformer";
import { IsEnum as IsEnum7, IsInt as IsInt7, IsOptional as IsOptional7, IsString as IsString7, MaxLength, Min as Min7, ValidateIf as ValidateIf4 } from "class-validator";
var GetDeliveriesParams = class {
  constructor() {
    this.page = 1;
    this.limit = 20;
  }
};
__decorateClass([
  ApiPropertyOptional9({ description: "\uD398\uC774\uC9C0 \uBC88\uD638", example: 1, minimum: 1, default: 1, type: Number }),
  IsOptional7(),
  Type7(() => Number),
  IsInt7(),
  Min7(1)
], GetDeliveriesParams.prototype, "page", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uD398\uC774\uC9C0\uB2F9 \uD56D\uBAA9 \uC218", example: 20, minimum: 1, default: 20, type: Number }),
  IsOptional7(),
  Type7(() => Number),
  IsInt7(),
  Min7(1)
], GetDeliveriesParams.prototype, "limit", 2);
var DeliveryListItemDto = class {
};
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 ID", example: 1, type: Number })
], DeliveryListItemDto.prototype, "id", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0DD\uC131\uC77C", type: String, format: "date-time" })
], DeliveryListItemDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uC815\uC77C", type: String, format: "date-time" })
], DeliveryListItemDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 \uC0C1\uD0DC", enum: import_parchment11.DELIVERY_STATE, example: import_parchment11.DELIVERY_STATE.PREPARING })
], DeliveryListItemDto.prototype, "state", 2);
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 \uC720\uD615", enum: import_parchment11.DELIVERY_KIND, example: import_parchment11.DELIVERY_KIND.DELIVERY })
], DeliveryListItemDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uB839\uC778 \uC774\uB984", type: String })
], DeliveryListItemDto.prototype, "receiverName", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uB839\uC778 \uC804\uD654", type: String })
], DeliveryListItemDto.prototype, "receiverPhone", 2);
__decorateClass([
  ApiProperty12({ description: "\uC6B0\uD3B8\uBC88\uD638", type: String })
], DeliveryListItemDto.prototype, "zipcode", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uC18C1", type: String })
], DeliveryListItemDto.prototype, "address1", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC8FC\uC18C2", type: String })
], DeliveryListItemDto.prototype, "address2", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uBA54\uBAA8", type: String })
], DeliveryListItemDto.prototype, "memo", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uD0DD\uBC30\uC0AC", type: String })
], DeliveryListItemDto.prototype, "carrier", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC6B4\uC1A1\uC7A5 \uBC88\uD638", type: String })
], DeliveryListItemDto.prototype, "trackingNumber", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC8FC\uBB38\uBA85(\uC8FC\uBB38 \uC81C\uBAA9)", type: String })
], DeliveryListItemDto.prototype, "orderTitle", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC8FC\uBB38 \uC77C\uC2DC", type: String, format: "date-time" })
], DeliveryListItemDto.prototype, "orderedAt", 2);
var GetDeliveriesResponse = class {
};
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 \uBAA9\uB85D", type: [DeliveryListItemDto] })
], GetDeliveriesResponse.prototype, "data", 2);
__decorateClass([
  ApiProperty12({ description: "\uD398\uC774\uC9C0\uB124\uC774\uC158", type: PaginationMeta })
], GetDeliveriesResponse.prototype, "meta", 2);
var DeliveryDetailProductDto = class {
};
__decorateClass([
  ApiProperty12({ description: "\uC0C1\uD488 ID", example: 1, type: Number })
], DeliveryDetailProductDto.prototype, "productId", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0C1\uD488\uBA85", type: String })
], DeliveryDetailProductDto.prototype, "title", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0C1\uD488 slug", type: String })
], DeliveryDetailProductDto.prototype, "slug", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC0C1\uD488 \uC774\uBBF8\uC9C0 URL", type: String, nullable: true })
], DeliveryDetailProductDto.prototype, "imageUrl", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0C1\uD488 \uC6D0\uAC00", example: 5e4, type: Number })
], DeliveryDetailProductDto.prototype, "originalPrice", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0C1\uD488 \uD560\uC778 \uAE08\uC561", example: 1e4, type: Number })
], DeliveryDetailProductDto.prototype, "discount", 2);
var DeliveryDetailDto = class {
};
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 ID", example: 1, type: Number })
], DeliveryDetailDto.prototype, "id", 2);
__decorateClass([
  ApiProperty12({ description: "\uC0DD\uC131\uC77C", type: String, format: "date-time" })
], DeliveryDetailDto.prototype, "createdAt", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uC815\uC77C", type: String, format: "date-time" })
], DeliveryDetailDto.prototype, "updatedAt", 2);
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 \uC0C1\uD0DC", enum: import_parchment11.DELIVERY_STATE, example: import_parchment11.DELIVERY_STATE.PREPARING })
], DeliveryDetailDto.prototype, "state", 2);
__decorateClass([
  ApiProperty12({ description: "\uBC30\uC1A1 \uC720\uD615", enum: import_parchment11.DELIVERY_KIND, example: import_parchment11.DELIVERY_KIND.DELIVERY })
], DeliveryDetailDto.prototype, "kind", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uB839\uC778 \uC774\uB984", type: String })
], DeliveryDetailDto.prototype, "receiverName", 2);
__decorateClass([
  ApiProperty12({ description: "\uC218\uB839\uC778 \uC804\uD654", type: String })
], DeliveryDetailDto.prototype, "receiverPhone", 2);
__decorateClass([
  ApiProperty12({ description: "\uC6B0\uD3B8\uBC88\uD638", type: String })
], DeliveryDetailDto.prototype, "zipcode", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uC18C1", type: String })
], DeliveryDetailDto.prototype, "address1", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC8FC\uC18C2", type: String })
], DeliveryDetailDto.prototype, "address2", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uBA54\uBAA8", type: String })
], DeliveryDetailDto.prototype, "memo", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uD0DD\uBC30\uC0AC", type: String })
], DeliveryDetailDto.prototype, "carrier", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC6B4\uC1A1\uC7A5 \uBC88\uD638", type: String })
], DeliveryDetailDto.prototype, "trackingNumber", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38 \uCC98\uB9AC ID", example: 1, type: Number })
], DeliveryDetailDto.prototype, "orderTransactionId", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38\uC11C ID", example: 1, type: Number })
], DeliveryDetailDto.prototype, "orderSheetId", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38\uC790 \uACC4\uC815 ID", example: 1, type: Number })
], DeliveryDetailDto.prototype, "accountId", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38\uC790 \uC774\uB984", type: String })
], DeliveryDetailDto.prototype, "buyerName", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38\uC790 \uC774\uBA54\uC77C", type: String })
], DeliveryDetailDto.prototype, "buyerEmail", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38\uC790 \uC804\uD654\uBC88\uD638", type: String })
], DeliveryDetailDto.prototype, "buyerPhone", 2);
__decorateClass([
  ApiProperty12({ description: "\uC8FC\uBB38 \uC77C\uC2DC", type: String, format: "date-time" })
], DeliveryDetailDto.prototype, "orderedAt", 2);
__decorateClass([
  ApiProperty12({ description: "\uC5F0\uACB0\uB41C \uC8FC\uBB38 \uC0C1\uD488 \uBAA9\uB85D", type: () => [DeliveryDetailProductDto] })
], DeliveryDetailDto.prototype, "products", 2);
var UpdateDeliveryDto = class {
};
__decorateClass([
  ApiPropertyOptional9({
    description: "\uBC30\uC1A1 \uC0C1\uD0DC",
    enum: import_parchment11.DELIVERY_STATE,
    example: import_parchment11.DELIVERY_STATE.SHIPPED
  }),
  IsOptional7(),
  IsEnum7(import_parchment11.DELIVERY_STATE)
], UpdateDeliveryDto.prototype, "state", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uD0DD\uBC30\uC0AC", example: "CJ\uB300\uD55C\uD1B5\uC6B4", type: String }),
  ValidateIf4((dto) => dto.carrier !== void 0),
  IsString7(),
  MaxLength(20)
], UpdateDeliveryDto.prototype, "carrier", 2);
__decorateClass([
  ApiPropertyOptional9({ description: "\uC6B4\uC1A1\uC7A5 \uBC88\uD638", example: "1234567890", type: String }),
  ValidateIf4((dto) => dto.trackingNumber !== void 0),
  IsString7(),
  MaxLength(32)
], UpdateDeliveryDto.prototype, "trackingNumber", 2);

// src/system.dto.ts
import { ApiProperty as ApiProperty13 } from "@nestjs/swagger";
import { IsNotEmpty as IsNotEmpty6, IsString as IsString8, MinLength as MinLength2 } from "class-validator";
var ResetRedisCacheDto = class {
};
__decorateClass([
  ApiProperty13({
    description: "\uAD00\uB9AC\uC790 \uD604\uC7AC \uBE44\uBC00\uBC88\uD638 (\uC7AC\uAC80\uC99D\uC6A9)",
    example: "your-password",
    type: String,
    minLength: 8
  }),
  IsString8(),
  IsNotEmpty6(),
  MinLength2(8, { message: "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C 8\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4." })
], ResetRedisCacheDto.prototype, "password", 2);
export {
  ACCOUNT_FILTER_FIELDS,
  ACCOUNT_KIND_OPTIONS_ORDER,
  ACCOUNT_SEARCH_FIELDS,
  ACCOUNT_SORT_FIELDS,
  ACCOUNT_SORT_ORDERS,
  ADMIN_ROLES,
  AccountDetailDto,
  AccountEnrollmentListItemDto,
  AccountResponseDto,
  BatchUpdateChapterItem,
  BatchUpdateChaptersDto,
  BatchUpdateLessonItem,
  BatchUpdateLessonsDto,
  COURSE_LEVEL_VALUES,
  CategorySimpleDto,
  CategorySummaryDto,
  ChapterResponseDto,
  CourseDetailDto,
  CourseFilterKey,
  CourseResponseDto,
  CourseSortBy,
  CourseSummaryDto,
  CreateChapterDto,
  CreateCourseDto,
  CreateEnrollmentsByRequest,
  CreateEnrollmentsResponse,
  CreateInstructorDto,
  CreateLessonDto,
  CreateProductDto,
  CreateSpecialProductEnrollmentsRequest,
  DeliveryDetailDto,
  DeliveryDetailProductDto,
  DeliveryListItemDto,
  ENROLLMENT_STATE_LABELS,
  EnrollmentByCourseDto,
  EnrollmentByProductDto,
  EnrollmentDetailDto,
  EnrollmentListItemDto,
  FilterField,
  FilterKey,
  FilterValue,
  GetAccountEnrollmentsResponse,
  GetAccountsParams,
  GetCoursesParams,
  GetDeliveriesParams,
  GetDeliveriesResponse,
  GetEnrollmentsByCourseParams,
  GetEnrollmentsByProductParams,
  GetEnrollmentsParams,
  GetEnrollmentsResponse,
  GetInstructorsParams,
  GetInstructorsResponse,
  GetPaymentsParams,
  GetProductsParams,
  GetTargetCourseAndAccountIdsQuery,
  GetTargetCourseAndAccountIdsResponse,
  InstructorResponseDto,
  InstructorSummaryDto,
  LessonDetailDto,
  LoginRequest,
  LoginResponse,
  OrderSheetDetailDto,
  OrderTransactionDetailDto,
  OrderTransactionPaymentDto,
  OrderTransactionProductDto,
  OrderTransactionSummaryDto,
  PAYMENT_STATE_BADGE_VARIANT,
  PAYMENT_STATE_LABELS,
  PRODUCT_ITEM_KIND_LABELS,
  PRODUCT_ITEM_STATE_LABELS,
  PRODUCT_KIND_LABELS,
  PRODUCT_PACKAGE_KIND_LABELS,
  PRODUCT_STATE_LABELS,
  PaginatedResponseDto,
  PaginationMeta,
  PaymentDetailDto,
  PaymentFilterKey,
  PaymentProductSummaryDto,
  PaymentSortBy,
  PaymentSummaryDto,
  ProductDetailDto,
  ProductFilterKey,
  ProductItemConnectionDto,
  ProductItemDetailDto,
  ProductItemDto,
  ProductResponseDto,
  ProductSortBy,
  ROLE_LABELS,
  ROLE_PRIORITY,
  RefreshTokenResponse,
  ResetAdminPasswordDto,
  ResetRedisCacheDto,
  SocialAccountDto,
  SortField,
  SortFilterOptions,
  SortOrder,
  UpdateAccountDto,
  UpdateChapterDto,
  UpdateCourseDto,
  UpdateDeliveryDto,
  UpdateEnrollmentStateDto,
  UpdateInstructorDto,
  UpdateLessonDto,
  UpdateProductDto,
  User,
  canChangeEnrollmentState,
  compareRolePriority,
  getAccountOptions,
  getFilterValues,
  getHigherRoles,
  hasRoleOrHigher
};
